var Te = { exports: {} }, W = typeof Reflect == "object" ? Reflect : null, Ve = W && typeof W.apply == "function" ? W.apply : function(e, n, r) {
  return Function.prototype.apply.call(e, n, r);
}, ue;
W && typeof W.ownKeys == "function" ? ue = W.ownKeys : Object.getOwnPropertySymbols ? ue = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : ue = function(e) {
  return Object.getOwnPropertyNames(e);
};
function on(t) {
  console && console.warn && console.warn(t);
}
var gt = Number.isNaN || function(e) {
  return e !== e;
};
function y() {
  y.init.call(this);
}
Te.exports = y;
Te.exports.once = ln;
y.EventEmitter = y;
y.prototype._events = void 0;
y.prototype._eventsCount = 0;
y.prototype._maxListeners = void 0;
var We = 10;
function ge(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(y, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return We;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || gt(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    We = t;
  }
});
y.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
y.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || gt(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function yt(t) {
  return t._maxListeners === void 0 ? y.defaultMaxListeners : t._maxListeners;
}
y.prototype.getMaxListeners = function() {
  return yt(this);
};
y.prototype.emit = function(e) {
  for (var n = [], r = 1; r < arguments.length; r++) n.push(arguments[r]);
  var s = e === "error", i = this._events;
  if (i !== void 0)
    s = s && i.error === void 0;
  else if (!s)
    return !1;
  if (s) {
    var o;
    if (n.length > 0 && (o = n[0]), o instanceof Error)
      throw o;
    var c = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw c.context = o, c;
  }
  var a = i[e];
  if (a === void 0)
    return !1;
  if (typeof a == "function")
    Ve(a, this, n);
  else
    for (var u = a.length, l = Et(a, u), r = 0; r < u; ++r)
      Ve(l[r], this, n);
  return !0;
};
function vt(t, e, n, r) {
  var s, i, o;
  if (ge(n), i = t._events, i === void 0 ? (i = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (i.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    n.listener ? n.listener : n
  ), i = t._events), o = i[e]), o === void 0)
    o = i[e] = n, ++t._eventsCount;
  else if (typeof o == "function" ? o = i[e] = r ? [n, o] : [o, n] : r ? o.unshift(n) : o.push(n), s = yt(t), s > 0 && o.length > s && !o.warned) {
    o.warned = !0;
    var c = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    c.name = "MaxListenersExceededWarning", c.emitter = t, c.type = e, c.count = o.length, on(c);
  }
  return t;
}
y.prototype.addListener = function(e, n) {
  return vt(this, e, n, !1);
};
y.prototype.on = y.prototype.addListener;
y.prototype.prependListener = function(e, n) {
  return vt(this, e, n, !0);
};
function cn() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function wt(t, e, n) {
  var r = { fired: !1, wrapFn: void 0, target: t, type: e, listener: n }, s = cn.bind(r);
  return s.listener = n, r.wrapFn = s, s;
}
y.prototype.once = function(e, n) {
  return ge(n), this.on(e, wt(this, e, n)), this;
};
y.prototype.prependOnceListener = function(e, n) {
  return ge(n), this.prependListener(e, wt(this, e, n)), this;
};
y.prototype.removeListener = function(e, n) {
  var r, s, i, o, c;
  if (ge(n), s = this._events, s === void 0)
    return this;
  if (r = s[e], r === void 0)
    return this;
  if (r === n || r.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete s[e], s.removeListener && this.emit("removeListener", e, r.listener || n));
  else if (typeof r != "function") {
    for (i = -1, o = r.length - 1; o >= 0; o--)
      if (r[o] === n || r[o].listener === n) {
        c = r[o].listener, i = o;
        break;
      }
    if (i < 0)
      return this;
    i === 0 ? r.shift() : an(r, i), r.length === 1 && (s[e] = r[0]), s.removeListener !== void 0 && this.emit("removeListener", e, c || n);
  }
  return this;
};
y.prototype.off = y.prototype.removeListener;
y.prototype.removeAllListeners = function(e) {
  var n, r, s;
  if (r = this._events, r === void 0)
    return this;
  if (r.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[e]), this;
  if (arguments.length === 0) {
    var i = Object.keys(r), o;
    for (s = 0; s < i.length; ++s)
      o = i[s], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = r[e], typeof n == "function")
    this.removeListener(e, n);
  else if (n !== void 0)
    for (s = n.length - 1; s >= 0; s--)
      this.removeListener(e, n[s]);
  return this;
};
function Ot(t, e, n) {
  var r = t._events;
  if (r === void 0)
    return [];
  var s = r[e];
  return s === void 0 ? [] : typeof s == "function" ? n ? [s.listener || s] : [s] : n ? un(s) : Et(s, s.length);
}
y.prototype.listeners = function(e) {
  return Ot(this, e, !0);
};
y.prototype.rawListeners = function(e) {
  return Ot(this, e, !1);
};
y.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : bt.call(t, e);
};
y.prototype.listenerCount = bt;
function bt(t) {
  var e = this._events;
  if (e !== void 0) {
    var n = e[t];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
y.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ue(this._events) : [];
};
function Et(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r)
    n[r] = t[r];
  return n;
}
function an(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function un(t) {
  for (var e = new Array(t.length), n = 0; n < e.length; ++n)
    e[n] = t[n].listener || t[n];
  return e;
}
function ln(t, e) {
  return new Promise(function(n, r) {
    function s(o) {
      t.removeListener(e, i), r(o);
    }
    function i() {
      typeof t.removeListener == "function" && t.removeListener("error", s), n([].slice.call(arguments));
    }
    $t(t, e, i, { once: !0 }), e !== "error" && dn(t, s, { once: !0 });
  });
}
function dn(t, e, n) {
  typeof t.on == "function" && $t(t, "error", e, n);
}
function $t(t, e, n, r) {
  if (typeof t.on == "function")
    r.once ? t.once(e, n) : t.on(e, n);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function s(i) {
      r.once && t.removeEventListener(e, s), n(i);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var hn = Te.exports;
class fn extends hn.EventEmitter {
  on(e, n) {
    return super.on(e, n), this;
  }
  emit(e, ...n) {
    return super.emit(e, ...n);
  }
}
class Q extends Error {
}
const pn = 2147483647, mn = -2147483648, gn = Number.MAX_SAFE_INTEGER, yn = Number.MIN_SAFE_INTEGER, T = Symbol("missing"), It = Object.freeze(
  new Error("mingo: cycle detected while processing object/array")
), vn = "[object Object]", wn = /^\[object ([a-zA-Z0-9]+)\]$/, ce = (t) => {
  const e = Sn(t);
  let n = 0, r = e.length;
  for (; r; )
    n = (n << 5) - n ^ e.charCodeAt(--r);
  return n >>> 0;
}, St = /* @__PURE__ */ new Set([
  "null",
  "undefined",
  "boolean",
  "number",
  "string",
  "date",
  "regexp"
]), On = {
  null: 0,
  undefined: 0,
  number: 1,
  string: 2,
  object: 3,
  array: 4,
  boolean: 5,
  date: 6,
  regexp: 7,
  function: 8
}, M = (t, e) => {
  t === T && (t = void 0), e === T && (e = void 0);
  const [n, r] = [t, e].map(
    (s) => On[se(s).toLowerCase()]
  );
  return n !== r ? n - r : n === 1 || n === 2 || n === 6 ? t < e ? -1 : t > e ? 1 : 0 : L(t, e) ? 0 : t < e ? -1 : t > e ? 1 : 0;
};
function O(t, e) {
  if (!t)
    throw new Q(e);
}
const se = (t) => wn.exec(Object.prototype.toString.call(t))[1], be = (t) => typeof t == "boolean", F = (t) => typeof t == "string", A = (t) => !isNaN(t) && typeof t == "number", b = Array.isArray, w = (t) => {
  if (!t)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === Object.prototype || e === null) && vn === Object.prototype.toString.call(t);
}, ye = (t) => t === Object(t), he = (t) => t instanceof Date, re = (t) => t instanceof RegExp, Fe = (t) => typeof t == "function", $ = (t) => t == null, H = (t, e) => t.includes(e), xt = (t, e) => !H(t, e), J = (t, e = !0) => !!t || e && t === "", X = (t) => $(t) || F(t) && !t || t instanceof Array && t.length === 0 || w(t) && Object.keys(t).length === 0, He = (t) => t === T, Z = (t) => t instanceof Array ? t : [t], C = (t, e) => !!t && Object.prototype.hasOwnProperty.call(t, e), ke = (t) => typeof ArrayBuffer < "u" && ArrayBuffer.isView(t), bn = [he, re, ke], Ie = (t, e) => {
  if ($(t))
    return t;
  if (e.has(t))
    throw It;
  const n = t.constructor;
  if (bn.some((r) => r(t)))
    return new n(t);
  try {
    if (e.add(t), b(t))
      return t.map((r) => Ie(r, e));
    if (w(t)) {
      const r = {};
      for (const s in t)
        r[s] = Ie(t[s], e);
      return r;
    }
  } finally {
    e.delete(t);
  }
  return t;
}, Se = (t) => Ie(t, /* @__PURE__ */ new Set()), En = (t, e) => w(t) && w(e) || b(t) && b(e);
function xe(t, e, n) {
  if (n = n || { flatten: !1 }, He(t) || $(t))
    return e;
  if (He(e) || $(e))
    return t;
  if (!En(t, e)) {
    if (n.skipValidation)
      return e || t;
    throw Error("mismatched types. must both be array or object");
  }
  if (n.skipValidation = !0, b(t)) {
    const r = t, s = e;
    if (n.flatten) {
      let i = 0, o = 0;
      for (; i < r.length && o < s.length; )
        r[i] = xe(r[i++], s[o++], n);
      for (; o < s.length; )
        r.push(e[o++]);
    } else
      ae(r, s);
  } else
    for (const r in e)
      t[r] = xe(
        t[r],
        e[r],
        n
      );
  return t;
}
function _e(t, e = ce) {
  const n = /* @__PURE__ */ new Map();
  return t.forEach((r, s) => {
    const i = At(r, e);
    n.has(i) ? n.get(i).some((o) => L(t[o], r)) || n.get(i).push(s) : n.set(i, [s]);
  }), n;
}
function ze(t, e = ce) {
  if (t.some((c) => c.length == 0))
    return [];
  if (t.length === 1)
    return Array.from(t);
  const n = xn(
    t.map((c, a) => [a, c.length]),
    (c) => c[1]
  ), r = t[n[0][0]], s = _e(r, e), i = /* @__PURE__ */ new Map(), o = new Array();
  return s.forEach((c, a) => {
    const u = c.map((h) => r[h]), l = u.map((h) => 0), d = u.map((h) => [n[0][0], 0]);
    let f = !1;
    for (let h = 1; h < t.length; h++) {
      const [m, p] = n[h], g = t[m];
      if (i.has(h) || i.set(h, _e(g)), i.get(h).has(a)) {
        const v = i.get(h).get(a).map((_) => g[_]);
        f = u.map(
          (_, D) => v.some((nn, rn) => {
            const sn = l[D];
            return L(_, nn) && (l[D]++, m < d[D][0] && (d[D] = [m, i.get(h).get(a)[rn]])), sn < l[D];
          })
        ).some(Boolean);
      }
      if (!f)
        return;
    }
    f && ae(
      o,
      l.map((h, m) => h === t.length - 1 ? [u[m], d[m]] : T).filter((h) => h !== T)
    );
  }), o.sort((c, a) => {
    const [u, [l, d]] = c, [f, [h, m]] = a, p = M(l, h);
    return p !== 0 ? p : M(d, m);
  }).map((c) => c[0]);
}
function _t(t, e = 0) {
  const n = new Array();
  function r(s, i) {
    for (let o = 0, c = s.length; o < c; o++)
      b(s[o]) && (i > 0 || i < 0) ? r(s[o], Math.max(-1, i - 1)) : n.push(s[o]);
  }
  return r(t, e), n;
}
const $n = (t) => {
  let [e, n] = [
    Object.getPrototypeOf(t),
    Object.getOwnPropertyNames(t)
  ], r = e;
  for (; !n.length && e !== Object.prototype && e !== Array.prototype; )
    r = e, n = Object.getOwnPropertyNames(e), e = Object.getPrototypeOf(e);
  const s = {};
  return n.forEach((i) => s[i] = t[i]), [s, r];
};
function L(t, e) {
  if (t === e || Object.is(t, e))
    return !0;
  const n = !!t && t.constructor || t;
  if (t === null || e === null || t === void 0 || e === void 0 || n !== e.constructor || n === Function)
    return !1;
  if (n === Array || n === Object) {
    const i = Object.keys(t), o = Object.keys(e);
    if (i.length !== o.length || (/* @__PURE__ */ new Set([...i, ...o])).size != i.length)
      return !1;
    for (const c of i)
      if (!L(t[c], e[c]))
        return !1;
    return !0;
  }
  const r = Object.getPrototypeOf(t);
  return (ke(t) || r !== Object.prototype && r !== Array.prototype && Object.prototype.hasOwnProperty.call(r, "toString")) && t.toString() === e.toString();
}
function In(t, e = ce) {
  const n = t.map((r) => T);
  return _e(t, e).forEach((r, s) => {
    r.forEach((i) => n[i] = t[i]);
  }), n.filter((r) => r !== T);
}
const le = (t, e) => {
  if (t === null)
    return "null";
  if (t === void 0)
    return "undefined";
  const n = t.constructor;
  switch (n) {
    case RegExp:
    case Number:
    case Boolean:
    case Function:
    case Symbol:
      return t.toString();
    case String:
      return JSON.stringify(t);
    case Date:
      return t.toISOString();
  }
  if (ke(t))
    return n.name + "[" + t.toString() + "]";
  if (e.has(t))
    throw It;
  try {
    if (e.add(t), b(t))
      return "[" + t.map((o) => le(o, e)).join(",") + "]";
    if (n === Object)
      return "{" + Object.keys(t).sort().map((o) => o + ":" + le(t[o], e)).join(",") + "}";
    const r = Object.getPrototypeOf(t);
    if (r !== Object.prototype && r !== Array.prototype && Object.prototype.hasOwnProperty.call(r, "toString"))
      return n.name + "(" + JSON.stringify(t.toString()) + ")";
    const [s, i] = $n(t);
    return n.name + le(s, e);
  } finally {
    e.delete(t);
  }
}, Sn = (t) => le(t, /* @__PURE__ */ new Set());
function At(t, e) {
  return e = e || ce, $(t) ? null : e(t).toString();
}
function xn(t, e, n = M) {
  if (X(t))
    return t;
  const r = new Array(), s = new Array();
  for (let i = 0; i < t.length; i++) {
    const o = t[i], c = e(o, i);
    $(c) ? s.push(o) : r.push([c, o]);
  }
  return r.sort((i, o) => n(i[0], o[0])), ae(
    s,
    r.map((i) => i[1])
  );
}
function _n(t, e, n = ce) {
  if (t.length < 1)
    return /* @__PURE__ */ new Map();
  const r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
  for (let i = 0; i < t.length; i++) {
    const o = t[i], c = e(o, i), a = At(c, n);
    if (a === null)
      s.has(null) ? s.get(null).push(o) : s.set(null, [o]);
    else {
      const u = r.has(a) ? r.get(a).find((l) => L(l, c)) : null;
      $(u) ? (s.set(c, [o]), r.has(a) ? r.get(a).push(c) : r.set(a, [c])) : s.get(u).push(o);
    }
  }
  return s;
}
const Ee = 5e4;
function ae(t, ...e) {
  return t instanceof Array ? e.reduce(
    (n, r) => {
      let s = Math.ceil(r.length / Ee), i = 0;
      for (; s-- > 0; )
        Array.prototype.push.apply(
          n,
          r.slice(i, i + Ee)
        ), i += Ee;
      return n;
    },
    t
  ) : e.filter(ye).reduce((n, r) => (Object.assign(n, r), n), t);
}
function Ae(t, e) {
  return ye(t) ? t[e] : void 0;
}
function An(t, e) {
  if (e < 1)
    return t;
  for (; e-- && t.length === 1; )
    t = t[0];
  return t;
}
function z(t, e, n) {
  let r = 0;
  function s(o, c) {
    let a = o;
    for (let u = 0; u < c.length; u++) {
      const l = c[u];
      if (/^\d+$/.exec(l) === null && a instanceof Array) {
        if (u === 0 && r > 0)
          break;
        r += 1;
        const f = c.slice(u);
        a = a.reduce((h, m) => {
          const p = s(m, f);
          return p !== void 0 && h.push(p), h;
        }, []);
        break;
      } else
        a = Ae(a, l);
      if (a === void 0)
        break;
    }
    return a;
  }
  const i = St.has(se(t).toLowerCase()) ? t : s(t, e.split("."));
  return i instanceof Array && (n != null && n.unwrapArray) ? An(i, r) : i;
}
function de(t, e, n) {
  const r = e.split("."), s = r[0], i = r.slice(1).join("."), o = /^\d+$/.exec(s) !== null, c = r.length > 1;
  let a, u;
  if (t instanceof Array)
    if (o)
      a = Ae(t, Number(s)), c && (a = de(a, i, n)), a = [a];
    else {
      a = [];
      for (const l of t)
        u = de(l, e, n), n != null && n.preserveMissing ? (u === void 0 && (u = T), a.push(u)) : u !== void 0 && a.push(u);
    }
  else {
    if (u = Ae(t, s), c && (u = de(u, i, n)), u === void 0)
      return;
    a = n != null && n.preserveKeys ? { ...t } : {}, a[s] = u;
  }
  return a;
}
function Ce(t) {
  if (t instanceof Array)
    for (let e = t.length - 1; e >= 0; e--)
      t[e] === T ? t.splice(e, 1) : Ce(t[e]);
  else if (w(t))
    for (const e in t)
      C(t, e) && Ce(t[e]);
}
const Je = /^\d+$/;
function ie(t, e, n, r) {
  const s = e.split("."), i = s[0], o = s.slice(1).join(".");
  if (s.length === 1)
    (w(t) || b(t) && Je.test(i)) && n(t, i);
  else {
    r != null && r.buildGraph && $(t[i]) && (t[i] = {});
    const c = t[i];
    if (!c)
      return;
    const a = !!(s.length > 1 && Je.test(s[1]));
    c instanceof Array && (r != null && r.descendArray) && !a ? c.forEach((u) => ie(u, o, n, r)) : ie(c, o, n, r);
  }
}
function Cn(t, e, n) {
  ie(
    t,
    e,
    (r, s) => {
      r[s] = Fe(n) ? n(r[s]) : n;
    },
    { buildGraph: !0 }
  );
}
function Be(t, e, n) {
  ie(
    t,
    e,
    (r, s) => {
      if (r instanceof Array) {
        if (/^\d+$/.test(s))
          r.splice(parseInt(s), 1);
        else if (n && n.descendArray)
          for (const i of r)
            w(i) && delete i[s];
      } else w(r) && delete r[s];
    },
    n
  );
}
const Pn = /^\$[a-zA-Z0-9_]+$/;
function V(t) {
  return Pn.test(t);
}
function Ct(t) {
  if (St.has(se(t).toLowerCase()))
    return re(t) ? { $regex: t } : { $eq: t };
  if (ye(t)) {
    if (!Object.keys(t).some(V))
      return { $eq: t };
    if (C(t, "$regex")) {
      const n = { ...t };
      return n.$regex = new RegExp(
        t.$regex,
        t.$options
      ), delete n.$options, n;
    }
  }
  return t;
}
var te = /* @__PURE__ */ ((t) => (t.CLONE_ALL = "CLONE_ALL", t.CLONE_INPUT = "CLONE_INPUT", t.CLONE_OUTPUT = "CLONE_OUTPUT", t.CLONE_OFF = "CLONE_OFF", t))(te || {});
class U {
  constructor(e, n, r, s = Date.now()) {
    this._opts = e, this._root = n, this._local = r, this.timestamp = s, this.update(n, r);
  }
  /**
   * Initialize new ComputeOptions.
   *
   * @param options
   * @param root
   * @param local
   * @returns {ComputeOptions}
   */
  static init(e, n, r) {
    return e instanceof U ? new U(
      e._opts,
      $(e.root) ? n : e.root,
      Object.assign({}, e.local, r)
    ) : new U(e, n, r);
  }
  /** Updates the internal mutable state. */
  update(e, n) {
    var r;
    return this._root = e, this._local = n && Object.assign({}, n, {
      variables: Object.assign({}, (r = this._local) == null ? void 0 : r.variables, n == null ? void 0 : n.variables)
    }), this;
  }
  getOptions() {
    return Object.freeze({
      ...this._opts,
      context: k.from(this._opts.context)
    });
  }
  get root() {
    return this._root;
  }
  get local() {
    return this._local;
  }
  get idKey() {
    return this._opts.idKey;
  }
  get collation() {
    var e;
    return (e = this._opts) == null ? void 0 : e.collation;
  }
  get processingMode() {
    var e;
    return ((e = this._opts) == null ? void 0 : e.processingMode) || "CLONE_OFF";
  }
  get useStrictMode() {
    var e;
    return (e = this._opts) == null ? void 0 : e.useStrictMode;
  }
  get scriptEnabled() {
    var e;
    return (e = this._opts) == null ? void 0 : e.scriptEnabled;
  }
  get useGlobalContext() {
    var e;
    return (e = this._opts) == null ? void 0 : e.useGlobalContext;
  }
  get hashFunction() {
    var e;
    return (e = this._opts) == null ? void 0 : e.hashFunction;
  }
  get collectionResolver() {
    var e;
    return (e = this._opts) == null ? void 0 : e.collectionResolver;
  }
  get jsonSchemaValidator() {
    var e;
    return (e = this._opts) == null ? void 0 : e.jsonSchemaValidator;
  }
  get variables() {
    var e;
    return (e = this._opts) == null ? void 0 : e.variables;
  }
  get context() {
    var e;
    return (e = this._opts) == null ? void 0 : e.context;
  }
}
function fe(t) {
  return t instanceof U ? t.getOptions() : Object.freeze({
    idKey: "_id",
    scriptEnabled: !0,
    useStrictMode: !0,
    useGlobalContext: !0,
    processingMode: "CLONE_OFF",
    ...t,
    context: t != null && t.context ? k.from(t == null ? void 0 : t.context) : k.init({})
  });
}
var K = /* @__PURE__ */ ((t) => (t.ACCUMULATOR = "accumulator", t.EXPRESSION = "expression", t.PIPELINE = "pipeline", t.PROJECTION = "projection", t.QUERY = "query", t.WINDOW = "window", t))(K || {});
class k {
  constructor(e) {
    this.operators = {
      accumulator: {},
      expression: {},
      pipeline: {},
      projection: {},
      query: {},
      window: {}
    };
    for (const [n, r] of Object.entries(e))
      this.addOperators(n, r);
  }
  static init(e = {}) {
    return new k(e);
  }
  static from(e) {
    return new k(e.operators);
  }
  addOperators(e, n) {
    for (const [r, s] of Object.entries(n))
      this.getOperator(e, r) || (this.operators[e][r] = s);
    return this;
  }
  // register
  addAccumulatorOps(e) {
    return this.addOperators("accumulator", e);
  }
  addExpressionOps(e) {
    return this.addOperators("expression", e);
  }
  addQueryOps(e) {
    return this.addOperators("query", e);
  }
  addPipelineOps(e) {
    return this.addOperators("pipeline", e);
  }
  addProjectionOps(e) {
    return this.addOperators("projection", e);
  }
  addWindowOps(e) {
    return this.addOperators("window", e);
  }
  // getters
  getOperator(e, n) {
    return e in this.operators && this.operators[e][n] || null;
  }
}
const q = k.init();
function ve(t, e) {
  for (const [n, r] of Object.entries(e)) {
    O(
      Fe(r) && V(n),
      `'${n}' is not a valid operator`
    );
    const s = G(t, n, null);
    O(
      !s || r === s,
      `${n} already exists for '${t}' operators. Cannot change operator function once registered.`
    );
  }
  switch (t) {
    case "accumulator":
      q.addAccumulatorOps(e);
      break;
    case "expression":
      q.addExpressionOps(e);
      break;
    case "pipeline":
      q.addPipelineOps(e);
      break;
    case "projection":
      q.addProjectionOps(e);
      break;
    case "query":
      q.addQueryOps(e);
      break;
    case "window":
      q.addWindowOps(e);
      break;
  }
}
function G(t, e, n) {
  const { context: r, useGlobalContext: s } = n || {}, i = r ? r.getOperator(t, e) : null;
  return !i && s ? q.getOperator(t, e) : i;
}
const Ye = {
  $$ROOT(t, e, n) {
    return n.root;
  },
  $$CURRENT(t, e, n) {
    return t;
  },
  $$REMOVE(t, e, n) {
  },
  $$NOW(t, e, n) {
    return new Date(n.timestamp);
  }
}, Pe = {
  $$KEEP(t, e, n) {
    return t;
  },
  $$PRUNE(t, e, n) {
  },
  $$DESCEND(t, e, n) {
    if (!C(e, "$cond"))
      return t;
    let r;
    for (const [s, i] of Object.entries(t))
      if (ye(i)) {
        if (i instanceof Array) {
          const o = [];
          for (let c of i)
            w(c) && (c = Xe(c, e, n.update(c))), $(c) || o.push(c);
          r = o;
        } else
          r = Xe(
            i,
            e,
            n.update(i)
          );
        $(r) ? delete t[s] : t[s] = r;
      }
    return t;
  }
};
function I(t, e, n, r) {
  var i;
  const s = U.init(r, t);
  if (n = n || "", V(n)) {
    const o = G(
      "expression",
      n,
      r
    );
    if (o)
      return o(t, e, s);
    const c = G(
      "accumulator",
      n,
      r
    );
    if (c)
      return t instanceof Array || (t = I(t, e, null, s), e = null), O(t instanceof Array, `'${n}' target must be an array.`), c(
        t,
        e,
        // reset the root object for accumulators.
        s.update(null, s.local)
      );
    throw new Q(`operator '${n}' is not registered`);
  }
  if (F(e) && e.length > 0 && e[0] === "$") {
    if (C(Pe, e))
      return e;
    let o = s.root;
    const c = e.split(".");
    if (C(Ye, c[0]))
      o = Ye[c[0]](
        t,
        null,
        s
      ), e = e.slice(c[0].length + 1);
    else if (c[0].slice(0, 2) === "$$") {
      o = Object.assign(
        {},
        s.variables,
        // global vars
        // current item is added before local variables because the binding may be changed.
        { this: t },
        (i = s.local) == null ? void 0 : i.variables
        // local vars
      );
      const a = c[0].slice(2);
      O(
        C(o, a),
        `Use of undefined variable: ${a}`
      ), e = e.slice(2);
    } else
      e = e.slice(1);
    return e === "" ? o : z(o, e);
  }
  if (b(e))
    return e.map((o) => I(t, o, null, s));
  if (w(e)) {
    const o = {};
    for (const [c, a] of Object.entries(e))
      if (o[c] = I(t, a, c, s), [
        "expression",
        "accumulator"
        /* ACCUMULATOR */
      ].some(
        (u) => !!G(u, c, r)
      ))
        return O(
          Object.keys(e).length === 1,
          "Invalid aggregation expression '" + JSON.stringify(e) + "'"
        ), o[c];
    return o;
  }
  return e;
}
function Xe(t, e, n) {
  const r = I(t, e, null, n);
  return C(Pe, r) ? Pe[r](t, e, n) : r;
}
const jn = (t, e, n) => {
  const r = I(t, e, null, n);
  return J(r, n.useStrictMode) && r.every((s) => J(s, n.useStrictMode));
}, Mn = (t, e, n) => {
  const r = Z(e);
  if (r.length == 0)
    return !1;
  if (r.length == 1)
    return !I(t, r[0], null, n);
  throw "Expression $not takes exactly 1 argument";
}, Nn = (t, e, n) => {
  const r = I(t, e, null, n), s = n.useStrictMode;
  return J(r, s) && r.some((i) => J(i, s));
}, Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $and: jn,
  $not: Mn,
  $or: Nn
}, Symbol.toStringTag, { value: "Module" })), Ln = (t, e, n) => {
  const r = I(t, e, null, n);
  return r[0] > r[1] ? 1 : r[0] < r[1] ? -1 : 0;
};
function B(t) {
  return t instanceof Ze ? t : new Ze(t);
}
function Rn(...t) {
  let e = 0;
  return B(() => {
    for (; e < t.length; ) {
      const n = t[e].next();
      if (!n.done)
        return n;
      e++;
    }
    return { done: !0 };
  });
}
function Dn(t) {
  return !!t && typeof t == "object" && (t == null ? void 0 : t.next) instanceof Function;
}
function Tn(t, e) {
  const n = t.slice(e + 1);
  t.splice(e), Array.prototype.push.apply(t, n);
}
const je = new Error();
function Fn(t, e, n) {
  let r = !1, s = -1, i = 0;
  return function(o) {
    try {
      e:
        for (; !r; ) {
          let c = t();
          s++;
          let a = -1;
          const u = e.length;
          let l = !1;
          for (; ++a < u; ) {
            const d = e[a];
            switch (d.action) {
              case 0:
                c = d.func(c, s);
                break;
              case 1:
                if (!d.func(c, s))
                  continue e;
                break;
              case 2:
                --d.count, d.count || (l = !0);
                break;
              case 3:
                --d.count, d.count || Tn(e, a);
                continue e;
              default:
                break e;
            }
          }
          if (r = l, o)
            n[i++] = c;
          else
            return { value: c, done: !1 };
        }
    } catch (c) {
      if (c !== je)
        throw c;
    }
    return r = !0, { done: r };
  };
}
class Ze {
  /**
   * @param {*} source An iterable object or function.
   *    Array - return one element per cycle
   *    Object{next:Function} - call next() for the next value (this also handles generator functions)
   *    Function - call to return the next value
   * @param {Function} fn An optional transformation function
   */
  constructor(e) {
    this.iteratees = [], this.yieldedValues = [], this.isDone = !1;
    let n;
    if (e instanceof Function && (e = { next: e }), Dn(e)) {
      const r = e;
      n = () => {
        const s = r.next();
        if (s.done)
          throw je;
        return s.value;
      };
    } else if (e instanceof Array) {
      const r = e, s = r.length;
      let i = 0;
      n = () => {
        if (i < s)
          return r[i++];
        throw je;
      };
    } else if (!(e instanceof Function))
      throw new Q(
        "Lazy must be initialized with an array, generator, or function."
      );
    this.getNext = Fn(n, this.iteratees, this.yieldedValues);
  }
  /**
   * Add an iteratee to this lazy sequence
   */
  push(e, n) {
    return typeof n == "function" ? this.iteratees.push({ action: e, func: n }) : typeof n == "number" && this.iteratees.push({ action: e, count: n }), this;
  }
  next() {
    return this.getNext();
  }
  // Iteratees methods
  /**
   * Transform each item in the sequence to a new value
   * @param {Function} f
   */
  map(e) {
    return this.push(0, e);
  }
  /**
   * Select only items matching the given predicate
   * @param {Function} pred
   */
  filter(e) {
    return this.push(1, e);
  }
  /**
   * Take given numbe for values from sequence
   * @param {Number} n A number greater than 0
   */
  take(e) {
    return e > 0 ? this.push(2, e) : this;
  }
  /**
   * Drop a number of values from the sequence
   * @param {Number} n Number of items to drop greater than 0
   */
  drop(e) {
    return e > 0 ? this.push(3, e) : this;
  }
  // Transformations
  /**
   * Returns a new lazy object with results of the transformation
   * The entire sequence is realized.
   *
   * @param {Callback<Source, RawArray>} fn Tranform function of type (Array) => (Any)
   */
  transform(e) {
    const n = this;
    let r;
    return B(() => (r || (r = B(e(n.value()))), r.next()));
  }
  // Terminal methods
  /**
   * Returns the fully realized values of the iterators.
   * The return value will be an array unless `lazy.first()` was used.
   * The realized values are cached for subsequent calls.
   */
  value() {
    return this.isDone || (this.isDone = this.getNext(!0).done), this.yieldedValues;
  }
  /**
   * Execute the funcion for each value. Will stop when an execution returns false.
   * @param {Function} f
   * @returns {Boolean} false iff `f` return false for AnyVal execution, otherwise true
   */
  each(e) {
    for (; ; ) {
      const n = this.next();
      if (n.done)
        break;
      if (e(n.value) === !1)
        return !1;
    }
    return !0;
  }
  /**
   * Returns the reduction of sequence according the reducing function
   *
   * @param {*} f a reducing function
   * @param {*} initialValue
   */
  reduce(e, n) {
    let r = this.next();
    for (n === void 0 && !r.done && (n = r.value, r = this.next()); !r.done; )
      n = e(n, r.value), r = this.next();
    return n;
  }
  /**
   * Returns the number of matched items in the sequence
   */
  size() {
    return this.reduce(
      (e, n) => ++e,
      0
    );
  }
  [Symbol.iterator]() {
    return this;
  }
}
class kn {
  constructor(e, n) {
    this.pipeline = e, this.options = fe(n);
  }
  /**
   * Returns an `Lazy` iterator for processing results of pipeline
   *
   * @param {*} collection An array or iterator object
   * @returns {Iterator} an iterator object
   */
  stream(e) {
    let n = B(e);
    const r = this.options.processingMode;
    (r == te.CLONE_ALL || r == te.CLONE_INPUT) && n.map(Se);
    const s = new Array();
    if (!X(this.pipeline))
      for (const i of this.pipeline) {
        const o = Object.keys(i), c = o[0], a = G(
          K.PIPELINE,
          c,
          this.options
        );
        O(
          o.length === 1 && !!a,
          `invalid pipeline operator ${c}`
        ), s.push(c), n = a(n, i[c], this.options);
      }
    return (r == te.CLONE_OUTPUT || r == te.CLONE_ALL && ze([["$group", "$unwind"], s]).length) && n.map(Se), n;
  }
  /**
   * Return the results of the aggregation as an array.
   *
   * @param {*} collection
   * @param {*} query
   */
  run(e) {
    return this.stream(e).value();
  }
}
let zn = class {
  constructor(e, n, r, s) {
    this.source = e, this.predicate = n, this.projection = r, this.options = s, this.operators = [], this.result = null, this.buffer = [];
  }
  /** Returns the iterator from running the query */
  fetch() {
    return this.result ? this.result : (w(this.projection) && this.operators.push({ $project: this.projection }), this.result = B(this.source).filter(this.predicate), this.operators.length > 0 && (this.result = new kn(this.operators, this.options).stream(
      this.result
    )), this.result);
  }
  /** Returns an iterator with the buffered data included */
  fetchAll() {
    const e = B([...this.buffer]);
    return this.buffer = [], Rn(e, this.fetch());
  }
  /**
   * Return remaining objects in the cursor as an array. This method exhausts the cursor
   * @returns {Array}
   */
  all() {
    return this.fetchAll().value();
  }
  /**
   * Returns the number of objects return in the cursor. This method exhausts the cursor
   * @returns {Number}
   */
  count() {
    return this.all().length;
  }
  /**
   * Returns a cursor that begins returning results only after passing or skipping a number of documents.
   * @param {Number} n the number of results to skip.
   * @return {Cursor} Returns the cursor, so you can chain this call.
   */
  skip(e) {
    return this.operators.push({ $skip: e }), this;
  }
  /**
   * Constrains the size of a cursor's result set.
   * @param {Number} n the number of results to limit to.
   * @return {Cursor} Returns the cursor, so you can chain this call.
   */
  limit(e) {
    return this.operators.push({ $limit: e }), this;
  }
  /**
   * Returns results ordered according to a sort specification.
   * @param {Object} modifier an object of key and values specifying the sort order. 1 for ascending and -1 for descending
   * @return {Cursor} Returns the cursor, so you can chain this call.
   */
  sort(e) {
    return this.operators.push({ $sort: e }), this;
  }
  /**
   * Specifies the collation for the cursor returned by the `mingo.Query.find`
   * @param {*} spec
   */
  collation(e) {
    return this.options = { ...this.options, collation: e }, this;
  }
  /**
   * Returns the next document in a cursor.
   * @returns {Object | Boolean}
   */
  next() {
    if (this.buffer.length > 0)
      return this.buffer.pop();
    const e = this.fetch().next();
    if (!e.done)
      return e.value;
  }
  /**
   * Returns true if the cursor has documents and can be iterated.
   * @returns {boolean}
   */
  hasNext() {
    if (this.buffer.length > 0)
      return !0;
    const e = this.fetch().next();
    return e.done ? !1 : (this.buffer.push(e.value), !0);
  }
  /**
   * Applies a function to each document in a cursor and collects the return values in an array.
   * @param fn
   * @returns {Array}
   */
  map(e) {
    return this.all().map(e);
  }
  /**
   * Applies a JavaScript function for every document in a cursor.
   * @param fn
   */
  forEach(e) {
    this.all().forEach(e);
  }
  [Symbol.iterator]() {
    return this.fetchAll();
  }
};
class R {
  constructor(e, n) {
    this.condition = e, this.options = fe(n), this.compiled = [], this.compile();
  }
  compile() {
    O(
      w(this.condition),
      `query criteria must be an object: ${JSON.stringify(this.condition)}`
    );
    const e = {};
    for (const [n, r] of Object.entries(this.condition)) {
      if (n === "$where")
        Object.assign(e, { field: n, expr: r });
      else if (H(["$and", "$or", "$nor", "$expr", "$jsonSchema"], n))
        this.processOperator(n, n, r);
      else {
        O(!V(n), `unknown top level operator: ${n}`);
        for (const [s, i] of Object.entries(
          Ct(r)
        ))
          this.processOperator(n, s, i);
      }
      e.field && this.processOperator(
        e.field,
        e.field,
        e.expr
      );
    }
  }
  processOperator(e, n, r) {
    const s = G(
      K.QUERY,
      n,
      this.options
    );
    if (!s)
      throw new Q(`unknown query operator ${n}`);
    const i = s(e, r, this.options);
    this.compiled.push(i);
  }
  /**
   * Checks if the object passes the query criteria. Returns true if so, false otherwise.
   *
   * @param obj The object to test
   * @returns {boolean} True or false
   */
  test(e) {
    for (let n = 0, r = this.compiled.length; n < r; n++)
      if (!this.compiled[n](e))
        return !1;
    return !0;
  }
  /**
   * Returns a cursor to select matching documents from the input source.
   *
   * @param source A source providing a sequence of documents
   * @param projection An optional projection criteria
   * @returns {Cursor} A Cursor for iterating over the results
   */
  find(e, n) {
    return new zn(
      e,
      (r) => this.test(r),
      n || {},
      this.options
    );
  }
  /**
   * Remove matched documents from the collection returning the remainder
   *
   * @param collection An array of documents
   * @returns {Array} A new array with matching elements removed
   */
  remove(e) {
    return e.reduce((n, r) => (this.test(r) || n.push(r), n), []);
  }
}
function S(t) {
  const e = (n, r, s) => {
    const i = { unwrapArray: !0 }, o = Math.max(1, n.split(".").length - 1);
    return (c) => {
      const a = z(c, n, i);
      return t(a, r, { ...s, depth: o });
    };
  };
  return e.op = "query", e;
}
function ee(t) {
  return (e, n, r) => {
    const s = I(e, n, null, r);
    return t(...s);
  };
}
function qe(t, e, n) {
  if (L(t, e) || $(t) && $(e))
    return !0;
  if (t instanceof Array) {
    const r = L.bind(null, e);
    return t.some(r) || _t(t, n == null ? void 0 : n.depth).some(r);
  }
  return !1;
}
function Pt(t, e, n) {
  return !qe(t, e, n);
}
function jt(t, e, n) {
  return $(t) ? e.some((r) => r === null) : ze([Z(t), e], n == null ? void 0 : n.hashFunction).length > 0;
}
function Kn(t, e, n) {
  return !jt(t, e, n);
}
function Mt(t, e, n) {
  return we(t, e, (r, s) => M(r, s) < 0);
}
function Nt(t, e, n) {
  return we(t, e, (r, s) => M(r, s) <= 0);
}
function Lt(t, e, n) {
  return we(t, e, (r, s) => M(r, s) > 0);
}
function Rt(t, e, n) {
  return we(t, e, (r, s) => M(r, s) >= 0);
}
function qn(t, e, n) {
  return Z(t).some(
    (r) => e.length === 2 && r % e[0] === e[1]
  );
}
function Un(t, e, n) {
  const r = Z(t), s = (i) => F(i) && J(e.exec(i), n == null ? void 0 : n.useStrictMode);
  return r.some(s) || _t(r, 1).some(s);
}
function Gn(t, e, n) {
  return (e === !1 || e === 0) && t === void 0 || (e === !0 || e === 1) && t !== void 0;
}
function Qn(t, e, n) {
  if (!b(t) || !b(e) || !t.length || !e.length)
    return !1;
  let r = !0;
  for (const s of e) {
    if (!r)
      break;
    w(s) && H(Object.keys(s), "$elemMatch") ? r = Dt(t, s.$elemMatch, n) : s instanceof RegExp ? r = t.some((i) => typeof i == "string" && s.test(i)) : r = t.some((i) => L(s, i));
  }
  return r;
}
function Vn(t, e, n) {
  return Array.isArray(t) && t.length === e;
}
function Wn(t) {
  return V(t) && ["$and", "$or", "$nor"].indexOf(t) === -1;
}
function Dt(t, e, n) {
  if (b(t) && !X(t)) {
    let r = (o) => o, s = e;
    Object.keys(e).every(Wn) && (s = { temp: e }, r = (o) => ({ temp: o }));
    const i = new R(s, n);
    for (let o = 0, c = t.length; o < c; o++)
      if (i.test(r(t[o])))
        return !0;
  }
  return !1;
}
const et = (t) => t === null, tt = (t) => A(t) && t >= mn && t <= pn && t.toString().indexOf(".") === -1, nt = (t) => A(t) && t >= yn && t <= gn && t.toString().indexOf(".") === -1, Hn = {
  array: b,
  bool: be,
  boolean: be,
  date: he,
  decimal: A,
  double: A,
  int: tt,
  long: nt,
  number: A,
  null: et,
  object: w,
  regex: re,
  regexp: re,
  string: F,
  // added for completeness
  undefined: $,
  // deprecated
  function: (t) => {
    throw new Q("unsupported type key `function`.");
  },
  // Mongo identifiers
  1: A,
  //double
  2: F,
  3: w,
  4: b,
  6: $,
  // deprecated
  8: be,
  9: he,
  10: et,
  11: re,
  16: tt,
  18: nt,
  19: A
  //decimal
};
function rt(t, e, n) {
  const r = Hn[e];
  return r ? r(t) : !1;
}
function Jn(t, e, n) {
  return Array.isArray(e) ? e.findIndex((r) => rt(t, r)) >= 0 : rt(t, e);
}
function we(t, e, n) {
  return Z(t).some((r) => se(r) === se(e) && n(r, e));
}
const Bn = ee(qe), Yn = ee(Lt), Xn = ee(Rt), Zn = ee(Mt), er = ee(Nt), tr = ee(Pt), Ue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $cmp: Ln,
  $eq: Bn,
  $gt: Yn,
  $gte: Xn,
  $lt: Zn,
  $lte: er,
  $ne: tr
}, Symbol.toStringTag, { value: "Module" })), Tt = (t, e, n) => {
  if (X(e) || !w(e))
    return t;
  let r = M;
  const s = n.collation;
  return w(s) && F(s.locale) && (r = rr(s)), t.transform((i) => {
    const o = Object.keys(e);
    for (const c of o.reverse()) {
      const a = _n(
        i,
        (l) => z(l, c),
        n.hashFunction
      ), u = Array.from(a.keys()).sort(r);
      e[c] === -1 && u.reverse(), i = [], u.reduce(
        (l, d) => ae(l, a.get(d)),
        i
      );
    }
    return i;
  });
}, nr = {
  // Only strings that differ in base letters compare as unequal. Examples: a ≠ b, a = á, a = A.
  1: "base",
  //  Only strings that differ in base letters or accents and other diacritic marks compare as unequal.
  // Examples: a ≠ b, a ≠ á, a = A.
  2: "accent",
  // Strings that differ in base letters, accents and other diacritic marks, or case compare as unequal.
  // Other differences may also be taken into consideration. Examples: a ≠ b, a ≠ á, a ≠ A
  3: "variant"
  // case - Only strings that differ in base letters or case compare as unequal. Examples: a ≠ b, a = á, a ≠ A.
};
function rr(t) {
  const e = {
    sensitivity: nr[t.strength || 3],
    caseFirst: t.caseFirst === "off" ? "false" : t.caseFirst || "false",
    numeric: t.numericOrdering || !1,
    ignorePunctuation: t.alternate === "shifted"
  };
  (t.caseLevel || !1) === !0 && (e.sensitivity === "base" && (e.sensitivity = "case"), e.sensitivity === "accent" && (e.sensitivity = "variant"));
  const n = new Intl.Collator(t.locale, e);
  return (r, s) => {
    if (!F(r) || !F(s))
      return M(r, s);
    const i = n.compare(r, s);
    return i < 0 ? -1 : i > 0 ? 1 : 0;
  };
}
const Ft = (t, e, n) => t.take(e), sr = (t, e, n) => {
  const r = I(t, e, null, n), s = r[0];
  let i = r[1], o = r[2];
  return $(o) ? i < 0 ? (i = Math.max(0, s.length + i), o = s.length - i + 1) : (o = i, i = 0) : (i < 0 && (i = Math.max(0, s.length + i)), O(
    o > 0,
    "Invalid argument for $slice operator. Limit must be a positive number"
  ), o += i), s.slice(i, o);
}, st = (t, e) => {
  const n = {};
  return t.split("").forEach((r, s) => n[r] = e * (s + 1)), n;
};
({
  ...st("ABCDEFGHIKLM", 1),
  ...st("NOPQRSTUVWXY", -1)
});
const it = {
  undefined: null,
  null: null,
  NaN: NaN,
  Infinity: new Error(),
  "-Infinity": new Error()
};
function P(t, e = it) {
  const n = Object.assign({}, it, e), r = new Set(Object.keys(n));
  return (s, i, o) => {
    const c = I(s, i, null, o);
    if (r.has(`${c}`)) {
      const a = n[`${c}`];
      if (a instanceof Error)
        throw new Q(
          `cannot apply $${t.name} to -inf, value must in (-inf,inf)`
        );
      return a;
    }
    return t(c);
  };
}
P(Math.acos, {
  Infinity: 1 / 0,
  0: new Error()
});
P(Math.acosh, {
  Infinity: 1 / 0,
  0: new Error()
});
P(Math.asin);
P(Math.asinh, {
  Infinity: 1 / 0,
  "-Infinity": -1 / 0
});
P(Math.atan);
P(Math.atanh, {
  1: 1 / 0,
  "-1": -1 / 0
});
P(Math.cos);
P(Math.cosh, {
  "-Infinity": 1 / 0,
  Infinity: 1 / 0
  // [Math.PI]: -1,
});
const ir = Math.PI / 180;
P(
  (t) => t * ir,
  {
    Infinity: 1 / 0,
    "-Infinity": 1 / 0
  }
);
const or = 180 / Math.PI;
P(
  (t) => t * or,
  {
    Infinity: 1 / 0,
    "-Infinity": -1 / 0
  }
);
P(Math.sin);
P(Math.sinh, {
  "-Infinity": -1 / 0,
  Infinity: 1 / 0
});
P(Math.tan);
const kt = (t, e, n) => {
  if (X(e))
    return t;
  let r = Object.keys(e), s = !1;
  zt(e, n);
  const i = n.idKey;
  if (H(r, i)) {
    const c = e[i];
    (c === 0 || c === !1) && (r = r.filter(
      xt.bind(null, [i])
    ), s = r.length == 0);
  } else
    r.push(i);
  const o = U.init(n);
  return t.map((c) => Me(
    c,
    e,
    o.update(c),
    r,
    s
  ));
};
function Me(t, e, n, r, s) {
  let i = {}, o = !1, c = !1;
  const a = [];
  s && a.push(n.idKey);
  for (const u of r) {
    let l;
    const d = e[u];
    if (u !== n.idKey && H([0, !1], d) && (c = !0), u === n.idKey && X(d))
      l = t[u];
    else if (F(d))
      l = I(t, d, u, n);
    else if (!H([1, !0], d)) if (d instanceof Array)
      l = d.map((h) => {
        const m = I(t, h, null, n);
        return $(m) ? null : m;
      });
    else if (w(d)) {
      const h = d, m = Object.keys(d), p = m.length == 1 ? m[0] : "", g = G(
        K.PROJECTION,
        p,
        n
      );
      if (g)
        p === "$slice" ? Z(h[p]).every(A) ? (l = g(t, h[p], u, n), o = !0) : l = I(t, h, u, n) : l = g(t, h[p], u, n);
      else if (V(p))
        l = I(t, h[p], p, n);
      else if (C(t, u)) {
        zt(h, n);
        let v = t[u];
        v instanceof Array ? l = v.map(
          (_) => Me(_, h, n, m, !1)
        ) : (v = w(v) ? v : t, l = Me(
          v,
          h,
          n,
          m,
          !1
        ));
      } else
        l = I(t, d, null, n);
    } else {
      a.push(u);
      continue;
    }
    const f = de(t, u, {
      preserveMissing: !0
    });
    f !== void 0 && xe(i, f, {
      flatten: !0
    }), xt([0, 1, !1, !0], d) && (l === void 0 ? Be(i, u, { descendArray: !0 }) : Cn(i, u, l));
  }
  if (Ce(i), (o || c || s) && (i = ae({}, t, i), a.length > 0))
    for (const u of a)
      Be(i, u, { descendArray: !0 });
  return i;
}
function zt(t, e) {
  const n = [!1, !1];
  for (const [r, s] of Object.entries(t)) {
    if (r === (e == null ? void 0 : e.idKey))
      return;
    s === 0 || s === !1 ? n[0] = !0 : (s === 1 || s === !0) && (n[1] = !0), O(
      !(n[0] && n[1]),
      "Projection cannot have a mix of inclusion and exclusion."
    );
  }
}
const Kt = (t, e, n) => t.drop(e), cr = (t, e, n, r) => {
  const s = z(t, n), i = new R(e, r);
  O(s instanceof Array, "$elemMatch: argument must resolve to array");
  const o = [];
  for (let c = 0; c < s.length; c++)
    if (i.test(s[c])) {
      if (r.useStrictMode)
        return [s[c]];
      o.push(s[c]);
    }
  return o.length > 0 ? o : void 0;
}, ar = (t, e, n, r) => {
  const s = z(t, n), i = e;
  return b(s) ? sr(
    t,
    e instanceof Array ? [s, ...i] : [s, e],
    r
  ) : s;
}, qt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $elemMatch: cr,
  $slice: ar
}, Symbol.toStringTag, { value: "Module" })), ur = S(Qn), lr = S(Dt), dr = S(Vn), Oe = (t) => S(
  (e, n, r) => {
    let s = 0;
    if (n instanceof Array)
      for (const i of n)
        s = s | 1 << i;
    else
      s = n;
    return t(e & s, s);
  }
), hr = Oe((t, e) => t == 0), fr = Oe(
  (t, e) => t == e
), pr = Oe(
  (t, e) => t < e
), mr = Oe((t, e) => t > 0), gr = S(qe), yr = S(Lt), vr = S(Rt), wr = S(jt), Or = S(Mt), br = S(Nt), Er = S(Pt), $r = S(Kn), Ir = S(Gn), Sr = S(Jn);
function xr(t, e, n) {
  return (r) => I(r, e, null, n);
}
function _r(t, e, n) {
  if (!(n != null && n.jsonSchemaValidator))
    throw new Q(
      "Missing option 'jsonSchemaValidator'. Configure to use '$jsonSchema' operator."
    );
  const r = n == null ? void 0 : n.jsonSchemaValidator(e);
  return (s) => r(s);
}
const Ar = S(qn), Cr = S(Un);
function Pr(t, e, n) {
  O(
    n.scriptEnabled,
    "$where operator requires 'scriptEnabled' option to be true"
  );
  const r = e;
  return O(Fe(r), "$where only accepts a Function object"), (s) => J(r.call(s), n == null ? void 0 : n.useStrictMode);
}
const jr = (t, e, n) => {
  O(
    b(e),
    "Invalid expression: $and expects value to be an Array."
  );
  const r = e.map((s) => new R(s, n));
  return (s) => r.every((i) => i.test(s));
}, Ut = (t, e, n) => {
  O(b(e), "Invalid expression. $or expects value to be an Array");
  const r = e.map((s) => new R(s, n));
  return (s) => r.some((i) => i.test(s));
}, Mr = (t, e, n) => {
  O(
    b(e),
    "Invalid expression. $nor expects value to be an array."
  );
  const r = Ut("$or", e, n);
  return (s) => !r(s);
}, Nr = (t, e, n) => {
  const r = {};
  r[t] = Ct(e);
  const s = new R(r, n);
  return (i) => !s.test(i);
}, Ge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $all: ur,
  $and: jr,
  $bitsAllClear: hr,
  $bitsAllSet: fr,
  $bitsAnyClear: pr,
  $bitsAnySet: mr,
  $elemMatch: lr,
  $eq: gr,
  $exists: Ir,
  $expr: xr,
  $gt: yr,
  $gte: vr,
  $in: wr,
  $jsonSchema: _r,
  $lt: Or,
  $lte: br,
  $mod: Ar,
  $ne: Er,
  $nin: $r,
  $nor: Mr,
  $not: Nr,
  $or: Ut,
  $regex: Cr,
  $size: dr,
  $type: Sr,
  $where: Pr
}, Symbol.toStringTag, { value: "Module" }));
ve(K.EXPRESSION, {
  ...Ke,
  ...Ue
});
ve(K.PIPELINE, {
  $project: kt,
  $skip: Kt,
  $limit: Ft,
  $sort: Tt
});
ve(K.PROJECTION, qt);
ve(K.QUERY, Ge);
k.init().addExpressionOps({
  ...Ke,
  ...Ue
}).addPipelineOps({ $project: kt, $skip: Kt, $limit: Ft, $sort: Tt }).addProjectionOps(qt).addQueryOps(Ge);
function ot(t, e) {
  return new R(e).test(t);
}
const Qe = (t, e) => {
  switch (t) {
    case "deep":
      return Se(e);
    case "copy":
      return he(e) ? new Date(e) : b(e) ? [...e] : w(e) ? { ...e } : e;
    default:
      return e;
  }
}, Lr = /^[a-z]+[a-zA-Z0-9]*$/;
function Gt(t) {
  if (!t.includes(".$"))
    return [{ parent: t, selector: t }, []];
  const e = t.indexOf(".$"), n = t.indexOf("]"), r = t.substring(0, e), s = t.substring(e + 3, n);
  O(
    s === "" || Lr.test(s),
    "The filter <identifier> must begin with a lowercase letter and contain only alphanumeric characters."
  );
  const i = t.substring(n + 2), [o, c] = i ? Gt(i) : [];
  return [
    { selector: t, parent: r, child: s || "$", next: o },
    [s, ...c || []].filter(Boolean)
  ];
}
const x = (t, e, n, r, s) => {
  const { parent: i, child: o, next: c } = e;
  if (!o) {
    let u = !1;
    return ie(t, i, (d, f) => u = !!r(d, f) || u, s), u;
  }
  const a = z(t, i);
  return b(a) ? a.map((u, l) => n[o] && !n[o].test({ [o]: u }) ? !1 : c ? x(u, c, n, r, s) : r(a, l)).some(Boolean) : !1;
};
function j(t, e, n, r) {
  const s = [];
  for (const [i, o] of Object.entries(t)) {
    const [c, a] = Gt(i);
    if (!a.length)
      r(o, c, {}) && s.push(c.parent);
    else {
      const u = {};
      e.forEach((d) => {
        Object.keys(d).forEach((f) => {
          a.forEach((h) => {
            (f === h || f.startsWith(h + ".")) && (u[h] = u[h] || {}, Object.assign(u[h], { [f]: d[f] }));
          });
        });
      });
      const l = {};
      for (const [d, f] of Object.entries(u))
        l[d] = new R(f, n.queryOptions);
      r(o, c, l) && s.push(c.parent);
    }
  }
  return s;
}
const Rr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => {
  const c = { $each: [s] };
  return w(s) && C(s, "$each") && Object.assign(c, s), x(
    t,
    i,
    o,
    (a, u) => {
      const l = a[u] || (a[u] = []);
      return ze([l, c.$each]).length === c.$each.length ? !1 : (a[u] = Qe(r.cloneMode, In(l.concat(c.$each))), !0);
    },
    { buildGraph: !0 }
  );
}), Dr = /* @__PURE__ */ new Set(["and", "or", "xor"]), Tr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => {
  const c = Object.keys(s);
  return O(
    c.length === 1 && Dr.has(c[0]),
    `Invalid bit operator '${c[0]}'. Must be one of 'and', 'or', or 'xor'.`
  ), x(
    t,
    i,
    o,
    (a, u) => {
      let l = a[u];
      const d = s[c[0]];
      if (l !== void 0 && !(A(l) && A(d)))
        return !1;
      switch (l = l || 0, c[0]) {
        case "and":
          a[u] = l & d;
          break;
        case "or":
          a[u] = l | d;
          break;
        case "xor":
          a[u] = l ^ d;
          break;
      }
      return a[u] !== l;
    },
    { buildGraph: !0 }
  );
}), Fr = (t, e, n = [], r = {}) => {
  const s = Date.now();
  return j(e, n, r, (i, o, c) => x(
    t,
    o,
    c,
    (a, u) => (a[u] = s, !0),
    { buildGraph: !0 }
  ));
}, kr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => {
  if (!i.child) {
    const c = z(t, i.parent);
    O(
      c === void 0 || A(c),
      "cannot apply $inc to a value of non-numeric type"
    );
  }
  return x(
    t,
    i,
    o,
    (c, a) => (c[a] = (c[a] || (c[a] = 0)) + s, !0),
    { buildGraph: !0 }
  );
}), zr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => x(
  t,
  i,
  o,
  (c, a) => c[a] !== void 0 && M(c[a], s) > -1 ? !1 : (c[a] = s, !0),
  { buildGraph: !0 }
)), Kr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => x(
  t,
  i,
  o,
  (c, a) => c[a] !== void 0 && M(c[a], s) < 1 ? !1 : (c[a] = s, !0),
  { buildGraph: !0 }
)), qr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => x(
  t,
  i,
  o,
  (c, a) => {
    const u = c[a];
    return c[a] = c[a] === void 0 ? 0 : c[a] * s, c[a] !== u;
  },
  { buildGraph: !0 }
)), Ur = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => x(t, i, o, (c, a) => {
  const u = c[a];
  return O(
    b(u),
    `path '${i.selector}' contains an element of non-array type.`
  ), u.length ? (s === -1 ? u.splice(0, 1) : u.pop(), !0) : !1;
})), Qt = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => {
  const c = !w(s) || Object.keys(s).some(V), a = new R(
    c ? { k: s } : s,
    r.queryOptions
  ), u = c ? (l) => a.test({ k: l }) : (l) => a.test(l);
  return x(t, i, o, (l, d) => {
    const f = l[d], h = new Array();
    return f.map((p) => {
      const g = u(p);
      return g || h.push(p), g;
    }).some(Boolean) ? (l[d] = h, !0) : !1;
  });
}), Gr = (t, e, n = [], r = {}) => {
  const s = {};
  return Object.entries(e).forEach(([i, o]) => {
    s[i] = { $in: o };
  }), Qt(t, s, n, r);
}, Qr = Object.freeze([
  "$each",
  "$slice",
  "$sort",
  "$position"
]), Vr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => {
  const c = {
    $each: [s]
  };
  return w(s) && Qr.some((a) => C(s, a)) && Object.assign(c, s), x(
    t,
    i,
    o,
    (a, u) => {
      const l = a[u] || (a[u] = []), d = l.slice(0, c.$slice || l.length), f = l.length, h = A(c.$position) ? c.$position : l.length;
      if (l.splice(
        h,
        0,
        ...Qe(r.cloneMode, c.$each)
      ), c.$sort) {
        const m = w(c.$sort) ? Object.keys(c.$sort || {}).pop() : "", p = m ? c.$sort[m] : c.$sort, g = m ? (v) => z(v, m) : (v) => v;
        l.sort((v, _) => p * M(g(v), g(_)));
      }
      return A(c.$slice) && (c.$slice < 0 ? l.splice(0, l.length + c.$slice) : l.splice(c.$slice)), f != l.length || !L(d, l);
    },
    { descendArray: !0, buildGraph: !0 }
  );
}), Vt = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => x(
  t,
  i,
  o,
  (c, a) => L(c[a], s) ? !1 : (c[a] = Qe(r.cloneMode, s), !0),
  { buildGraph: !0 }
)), Wr = (t, e, n = [], r = {}) => {
  const s = [], i = j(e, n, r, (o, c, a) => x(t, c, a, (u, l) => C(u, l) ? (s.push(...Vt(t, { [o]: u[l] }, n, r)), delete u[l], !0) : !1));
  return Array.from(new Set(i.concat(s)));
}, Hr = (t, e, n = [], r = {}) => j(e, n, r, (s, i, o) => x(t, i, o, (c, a) => C(c, a) ? (b(c) ? c[a] = null : delete c[a], !0) : !1)), ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $addToSet: Rr,
  $bit: Tr,
  $currentDate: Fr,
  $inc: kr,
  $max: zr,
  $min: Kr,
  $mul: qr,
  $pop: Ur,
  $pull: Qt,
  $pullAll: Gr,
  $push: Vr,
  $rename: Wr,
  $set: Vt,
  $unset: Hr
}, Symbol.toStringTag, { value: "Module" }));
function Jr(t) {
  return t = {
    ...t,
    queryOptions: fe(t.queryOptions)
  }, t.queryOptions.context.addQueryOps(Ge).addExpressionOps(Ke).addExpressionOps(Ue), (e, n, r = [], s = {}, i = {}) => {
    const o = Object.assign({ cloneMode: "copy" }, t, i);
    Object.assign(o, {
      queryOptions: fe(
        Object.assign({ useStrictMode: !1 }, o == null ? void 0 : o.queryOptions)
      )
    }), r = r || [], s = s || {};
    const c = Object.entries(n);
    O(
      c.length === 1,
      "Update expression must contain only one operator."
    );
    const [a, u] = c[0];
    O(
      C(ct, a),
      `Update operator '${a}' is not supported.`
    );
    const l = ct[a];
    return Object.keys(s).length && !(s instanceof R ? s : new R(s, o.queryOptions)).test(e) ? [] : l(e, u, r, o);
  };
}
const Br = Jr({});
function Ne(t, e) {
  const n = Object.assign({}, t);
  return Br(n, e), n;
}
function oe(t, e) {
  if (Object.is(t, e))
    return !0;
  if (t instanceof RegExp && e instanceof RegExp)
    return t.toString() === e.toString();
  if (t instanceof Date && e instanceof Date)
    return t.getTime() === e.getTime();
  if (typeof t != "object" || typeof e != "object" || t === null || e === null)
    return !1;
  const n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length)
    return !1;
  for (let s = 0; s < n.length; s += 1) {
    const i = n[s];
    if (!r.includes(i) || !oe(t[i], e[i]))
      return !1;
  }
  return !0;
}
function Wt() {
  return Math.floor(Math.random() * 1e17).toString(16);
}
function ne(t) {
  if (typeof t == "function")
    throw new Error("Cloning functions is not supported");
  if (t === null || typeof t != "object")
    return t;
  if (t instanceof Date)
    return new Date(t.getTime());
  if (Array.isArray(t))
    return t.map((n) => ne(n));
  if (t instanceof Map) {
    const n = /* @__PURE__ */ new Map();
    return t.forEach((r, s) => {
      n.set(s, ne(r));
    }), n;
  }
  if (t instanceof Set) {
    const n = /* @__PURE__ */ new Set();
    return t.forEach((r) => {
      n.add(ne(r));
    }), n;
  }
  if (t instanceof RegExp)
    return new RegExp(t);
  const e = {};
  for (const n in t)
    Object.hasOwnProperty.call(t, n) && (e[n] = ne(t[n]));
  return e;
}
function at(t) {
  if (typeof structuredClone == "function")
    return structuredClone(t);
  /* istanbul ignore next -- @preserve */
  return ne(t);
}
function N(t) {
  return typeof t == "string" ? t : typeof t == "number" || typeof t == "boolean" ? t.toString() : t instanceof Date ? t.toISOString() : JSON.stringify(t);
}
function Y(t, e, n = Object.is) {
  let r = e;
  return {
    get() {
      return t && t.depend(), r;
    },
    set(i) {
      n(r, i) || (r = i, t && t.notify());
    }
  };
}
var Ht = function(t) {
  return function(e, n, r) {
    return t(e, n, r) * r;
  };
}, Le = function(t, e) {
  if (t)
    throw Error("Invalid sort config: " + e);
}, Jt = function(t) {
  var e = t || {}, n = e.asc, r = e.desc, s = n ? 1 : -1, i = n || r;
  Le(!i, "Expected `asc` or `desc` property"), Le(n && r, "Ambiguous object with `asc` and `desc` config properties");
  var o = t.comparer && Ht(t.comparer);
  return { order: s, sortBy: i, comparer: o };
}, Yr = function(t) {
  return function e(n, r, s, i, o, c, a) {
    var u, l;
    if (typeof n == "string")
      u = c[n], l = a[n];
    else if (typeof n == "function")
      u = n(c), l = n(a);
    else {
      var d = Jt(n);
      return e(d.sortBy, r, s, d.order, d.comparer || t, c, a);
    }
    var f = o(u, l, i);
    return (f === 0 || u == null && l == null) && r.length > s ? e(r[s], r, s + 1, i, o, c, a) : f;
  };
};
function Bt(t, e, n) {
  if (t === void 0 || t === !0)
    return function(i, o) {
      return e(i, o, n);
    };
  if (typeof t == "string")
    return Le(t.includes("."), "String syntax not allowed for nested properties."), function(i, o) {
      return e(i[t], o[t], n);
    };
  if (typeof t == "function")
    return function(i, o) {
      return e(t(i), t(o), n);
    };
  if (Array.isArray(t)) {
    var r = Yr(e);
    return function(i, o) {
      return r(t[0], t, 1, n, e, i, o);
    };
  }
  var s = Jt(t);
  return Bt(s.sortBy, s.comparer || e, s.order);
}
var $e = function(t, e, n, r) {
  var s;
  return Array.isArray(e) ? (Array.isArray(n) && n.length < 2 && (s = n, n = s[0]), e.sort(Bt(n, r, t))) : e;
};
function Yt(t) {
  var e = Ht(t.comparer);
  return function(n) {
    var r = Array.isArray(n) && !t.inPlaceSorting ? n.slice() : n;
    return {
      asc: function(s) {
        return $e(1, r, s, e);
      },
      desc: function(s) {
        return $e(-1, r, s, e);
      },
      by: function(s) {
        return $e(1, r, s, e);
      }
    };
  };
}
var Xt = function(t, e, n) {
  return t == null ? n : e == null ? -n : typeof t != typeof e ? typeof t < typeof e ? -1 : 1 : t < e ? -1 : t > e ? 1 : 0;
}, Xr = Yt({
  comparer: Xt
});
Yt({
  comparer: Xt,
  inPlaceSorting: !0
});
function pe(t, e) {
  const n = e.split(/[.[\]]/g);
  n[0] === "" && n.shift(), n[n.length - 1] === "" && n.pop();
  let r = t;
  for (let s = 0; s < n.length; s += 1) {
    const i = n[s];
    if (r == null || i.trim() === "")
      return;
    r = r[i];
  }
  if (r !== void 0)
    return r;
}
function Zr(t, e) {
  return Xr(t).by(Object.entries(e).map(([n, r]) => ({ [r === 1 ? "asc" : "desc"]: (i) => pe(i, n) })));
}
function ut(t, e, n, r = !1) {
  if (t == null)
    return t;
  const s = e.split(/[.[\]]/g);
  s[0] === "" && s.shift(), s[s.length - 1] === "" && s.pop();
  const i = (o) => {
    if (s.length > 1) {
      const c = s.shift(), a = !Number.isNaN(parseInt(s[0], 10));
      o[c] === void 0 && (o[c] = a ? [] : {}), i(o[c]);
    } else {
      if (r && n === void 0) {
        delete o[s[0]];
        return;
      }
      o[s[0]] = n;
    }
  };
  return i(t), t;
}
function es(t, e) {
  if (Object.values(e).every((s) => s === 0)) {
    const s = Object.assign({}, t);
    return Object.keys(e).forEach((i) => {
      pe(t, i) !== void 0 && ut(s, i, void 0, !0);
    }), s;
  }
  const r = {};
  return Object.entries(e).forEach(([s, i]) => {
    const o = pe(t, s);
    o !== void 0 && (o == null && i !== 1 || ut(r, s, i === 1 ? o : void 0));
  }), r;
}
function ts(t, e) {
  const n = /* @__PURE__ */ new Set();
  return t.filter((r) => {
    const s = typeof e == "function" ? e(r) : r[e];
    return !n.has(s) && n.add(s);
  });
}
class ns {
  constructor(e) {
    this.previousItems = [], this.callbacks = {
      added: [],
      addedBefore: [],
      changed: [],
      changedField: [],
      movedBefore: [],
      removed: []
    }, this.unbindEvents = e();
  }
  call(e, ...n) {
    this.callbacks[e].forEach(({ callback: r, options: s }) => {
      (!s.skipInitial || !s.isInitial) && r(...n);
    });
  }
  hasCallbacks(e) {
    return e.some((n) => this.callbacks[n].length > 0);
  }
  isEmpty() {
    return !this.hasCallbacks([
      "added",
      "addedBefore",
      "changed",
      "changedField",
      "movedBefore",
      "removed"
    ]);
  }
  runChecks(e) {
    const n = new Map(this.previousItems.map((s, i) => [
      s.id,
      { item: s, index: i, beforeItem: this.previousItems[i + 1] || null }
    ])), r = new Map(e.map((s, i) => [
      s.id,
      { item: s, index: i, beforeItem: e[i + 1] || null }
    ]));
    this.hasCallbacks(["changed", "changedField", "movedBefore", "removed"]) && n.forEach(({ item: s, index: i, beforeItem: o }) => {
      var c;
      const a = r.get(s.id);
      a ? (this.hasCallbacks(["changed", "changedField"]) && (oe(a.item, s) || (this.call("changed", a.item), this.hasCallbacks(["changedField"]) && ts([
        ...Object.keys(a.item),
        ...Object.keys(s)
      ], (l) => l).forEach((l) => {
        oe(a.item[l], s[l]) || this.call("changedField", a.item, l, s[l], a.item[l]);
      }))), a.index !== i && ((c = a.beforeItem) === null || c === void 0 ? void 0 : c.id) !== (o == null ? void 0 : o.id) && this.call("movedBefore", a.item, a.beforeItem)) : this.call("removed", s);
    }), this.hasCallbacks(["added", "addedBefore"]) && e.forEach((s, i) => {
      n.get(s.id) || (this.call("added", s), this.call("addedBefore", s, e[i + 1] || null));
    }), this.previousItems = e, Object.keys(this.callbacks).forEach((s) => {
      const i = s, o = this.callbacks[i];
      this.callbacks[i] = o.map((c) => Object.assign(Object.assign({}, c), { options: Object.assign(Object.assign({}, c.options), { isInitial: !1 }) }));
    });
  }
  stop() {
    this.unbindEvents();
  }
  addCallbacks(e, n = !1) {
    Object.keys(e).forEach((r) => {
      const s = r;
      this.callbacks[s].push({
        callback: e[s],
        options: { skipInitial: n, isInitial: !0 }
      });
    });
  }
  removeCallbacks(e) {
    Object.keys(e).forEach((n) => {
      const r = n, s = this.callbacks[r].findIndex(({ callback: i }) => i === e[r]);
      this.callbacks[r].splice(s, 1);
    });
  }
}
function lt(t) {
  return t ? t.isInScope ? t.isInScope() : !0 : !1;
}
class rs {
  constructor(e, n) {
    this.onCleanupCallbacks = [], this.getFilteredItems = e, this.options = n || {};
  }
  addGetters(e) {
    if (!lt(this.options.reactive))
      return e;
    const n = this.depend.bind(this);
    return Object.entries(e).reduce((r, [s, i]) => (Object.defineProperty(r, s, {
      get() {
        return n({
          changedField: (o) => (c, a) => {
            a !== s || c.id !== e.id || o();
          }
        }), i;
      },
      enumerable: !0,
      configurable: !0
    }), r), {});
  }
  transform(e) {
    const n = this.options.fieldTracking ? this.addGetters(e) : e;
    return this.options.transform ? this.options.transform(n) : n;
  }
  getItems() {
    const e = this.getFilteredItems(), { sort: n, skip: r, limit: s } = this.options, i = n ? Zr(e, n) : e, o = r ? i.slice(r) : i, c = s ? o.slice(0, s) : o, a = this.options.fields && this.options.fields.id === 0;
    return c.map((u) => this.options.fields ? Object.assign(Object.assign({}, a ? {} : { id: u.id }), es(u, this.options.fields)) : u);
  }
  depend(e) {
    if (!this.options.reactive || !lt(this.options.reactive))
      return;
    const n = this.options.reactive.create();
    n.depend();
    const r = () => n.notify();
    function s(o) {
      const c = e[o];
      return c === !0 ? r : (...a) => {
        typeof c == "function" && c(r)(...a);
      };
    }
    const i = this.observeRawChanges({
      added: s("added"),
      addedBefore: s("addedBefore"),
      changed: s("changed"),
      changedField: s("changedField"),
      movedBefore: s("movedBefore"),
      removed: s("removed")
    }, !0);
    this.options.reactive.onDispose && this.options.reactive.onDispose(() => i(), n), this.onCleanup(i);
  }
  ensureObserver() {
    if (!this.observer) {
      const e = new ns(() => {
        const n = () => {
          e.runChecks(this.getItems());
        }, r = this.options.bindEvents && this.options.bindEvents(n);
        return () => {
          r && r();
        };
      });
      this.onCleanup(() => e.stop()), this.observer = e;
    }
    return this.observer;
  }
  observeRawChanges(e, n = !1) {
    const r = this.ensureObserver();
    return r.addCallbacks(e, n), r.runChecks(this.getItems()), () => {
      r.removeCallbacks(e), r.isEmpty() && (r.stop(), this.observer = void 0);
    };
  }
  cleanup() {
    this.onCleanupCallbacks.forEach((e) => {
      e();
    }), this.onCleanupCallbacks = [];
  }
  onCleanup(e) {
    this.onCleanupCallbacks.push(e);
  }
  forEach(e) {
    const n = this.getItems();
    this.depend(Object.assign({ addedBefore: !0, removed: !0, movedBefore: !0 }, this.options.fieldTracking ? {} : { changed: !0 })), n.forEach((r) => {
      e(this.transform(r));
    });
  }
  map(e) {
    const n = [];
    return this.forEach((r) => {
      n.push(e(r));
    }), n;
  }
  fetch() {
    return this.map((e) => e);
  }
  count() {
    const e = this.getItems();
    return this.depend({
      added: !0,
      removed: !0
    }), e.length;
  }
  observeChanges(e, n = !1) {
    return this.observeRawChanges(Object.entries(e).reduce((r, [s, i]) => i ? Object.assign(Object.assign({}, r), { [s]: (o, c) => {
      const a = this.transform(o), u = c !== void 0, l = u && c ? this.transform(c) : null;
      return i(a, ...u ? [l] : []);
    } }) : r, {}), n);
  }
  requery() {
    this.observer && this.observer.runChecks(this.getItems());
  }
}
function ss(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(t); s < r.length; s++)
      e.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[s]) && (n[r[s]] = t[r[s]]);
  return n;
}
function Re(...t) {
  return t.length === 0 ? [] : [...new Set(t.reduce((e, n) => e.filter((r) => n.includes(r))))];
}
function is(t, e) {
  return t.reduce((n, r) => {
    /* istanbul ignore if -- @preserve */
    if (r.getItemPositions) {
      const o = r.getItemPositions(e);
      return o == null ? n : {
        matched: !0,
        positions: n.matched ? Re(n.positions, o) : o,
        optimizedSelector: n.optimizedSelector
      };
    }
    const s = r.query(e);
    if (!s.matched)
      return n;
    const i = Object.fromEntries(Object.entries(n.optimizedSelector).filter(([o]) => !s.fields.includes(o)));
    return {
      matched: !0,
      positions: [...new Set(n.matched ? Re(n.positions, s.positions) : s.positions)],
      optimizedSelector: i
    };
  }, {
    matched: !1,
    positions: [],
    optimizedSelector: Object.assign({}, e)
  });
}
function me(t, e) {
  if (e == null || Object.keys(e).length <= 0)
    return { matched: !1, positions: [], optimizedSelector: e };
  const { $and: n, $or: r } = e, s = ss(e, ["$and", "$or"]), i = is(t, s);
  let { matched: o, positions: c } = i;
  const a = i.optimizedSelector;
  if (Array.isArray(n)) {
    const u = [];
    for (const l of n) {
      const { matched: d, positions: f, optimizedSelector: h } = me(t, l);
      d ? (c = o ? Re(c, f) : f, o = !0, Object.keys(h).length > 0 && u.push(h)) : u.push(l);
    }
    u.length > 0 && (a.$and = u);
  }
  if (Array.isArray(r)) {
    const u = [];
    for (const l of r) {
      const { matched: d, positions: f, optimizedSelector: h } = me(t, l);
      d ? (c = [.../* @__PURE__ */ new Set([...c, ...f])], o = !0, Object.keys(h).length > 0 && u.push(h)) : u.push(l);
    }
    u.length > 0 && (a.$or = u);
  }
  return {
    matched: o,
    positions: c || [],
    optimizedSelector: a
  };
}
function ws(t) {
  return t;
}
const dt = [
  "$eq",
  "$gt",
  "$gte",
  "$lt",
  "$lte",
  "$in",
  "$nin",
  "$ne",
  "$exists",
  "$not",
  "$expr",
  "$jsonSchema",
  "$mod",
  "$regex",
  "$options",
  "$text",
  "$where",
  "$all",
  "$elemMatch",
  "$size",
  "$bitsAllClear",
  "$bitsAllSet",
  "$bitsAnyClear",
  "$bitsAnySet"
];
function ht(t) {
  if (typeof t != "object" || t == null)
    return !1;
  const e = Object.keys(t);
  return e.length === 0 || e.some((s) => !dt.includes(s)) ? !1 : e.every((s) => dt.includes(s));
}
function os(t, e) {
  if (e[t] instanceof RegExp)
    return null;
  if (e[t] != null) {
    if (ht(e[t])) {
      if (ht(e[t]) && Array.isArray(e[t].$in) && e[t].$in.length) {
        const r = Object.assign(Object.assign({}, e), { [t]: Object.assign({}, e[t]) });
        return delete r[t].$in, Object.keys(r[t]).length === 0 && delete r[t], e[t].$in.map(N);
      }
      return null;
    }
    return [N(e[t])];
  }
  return null;
}
function Zt(t, e) {
  return {
    query(n) {
      const r = os(t, n);
      return r == null ? { matched: !1 } : {
        matched: !0,
        positions: r.reduce((i, o) => [...i, ...e.get(o) || []], []),
        fields: [t]
      };
    },
    rebuild() {
    }
  };
}
function Os(t) {
  const e = /* @__PURE__ */ new Map();
  return Object.assign(Object.assign({}, Zt(t, e)), { rebuild(n) {
    e.clear(), n.forEach((r, s) => {
      const i = N(pe(r, t)), o = e.get(i) || /* @__PURE__ */ new Set();
      o.add(s), e.set(i, o);
    });
  } });
}
function ft(t) {
  return t.added.length > 0 || t.modified.length > 0 || t.removed.length > 0;
}
function cs(t, { added: e, modified: n, removed: r }) {
  const s = t.slice();
  return e.forEach((i) => {
    s.push(i);
  }), n.forEach((i) => {
    const o = s.findIndex(({ id: c }) => c === i.id);
    o !== -1 && (s[o] = i);
  }), r.forEach((i) => {
    const o = s.findIndex(({ id: c }) => c === i.id);
    o !== -1 && s.splice(o, 1);
  }), s;
}
class E extends fn {
  static batch(e) {
    E.batchOperationInProgress = !0, E.collections.reduce((n, r) => () => r.batch(() => n()), e)(), E.batchOperationInProgress = !1;
  }
  constructor(e) {
    var n, r, s, i;
    if (super(), this.persistenceAdapter = null, this.indexProviders = [], this.indicesOutdated = !1, this.idIndex = /* @__PURE__ */ new Map(), this.batchOperationInProgress = !1, this.isDisposed = !1, E.collections.push(this), this.options = Object.assign({ memory: [] }, e), this.debugMode = (n = this.options.enableDebugMode) !== null && n !== void 0 ? n : E.debugMode, this.indexProviders = [
      Zt("id", this.idIndex),
      ...this.options.indices || []
    ], this.rebuildIndices(), this.isPullingSignal = Y((r = this.options.reactivity) === null || r === void 0 ? void 0 : r.create(), !!(e != null && e.persistence)), this.isPushingSignal = Y((s = this.options.reactivity) === null || s === void 0 ? void 0 : s.create(), !1), this.on("persistence.pullStarted", () => {
      this.isPullingSignal.set(!0);
    }), this.on("persistence.pullCompleted", () => {
      this.isPullingSignal.set(!1);
    }), this.on("persistence.pushStarted", () => {
      this.isPushingSignal.set(!0);
    }), this.on("persistence.pushCompleted", () => {
      this.isPushingSignal.set(!1);
    }), this.persistenceAdapter = (i = this.options.persistence) !== null && i !== void 0 ? i : null, this.persistenceAdapter) {
      let o = 0, c = !1;
      const a = { added: [], modified: [], removed: [] }, u = async (h) => {
        if (!this.persistenceAdapter)
          throw new Error("Persistence adapter not found");
        this.emit("persistence.pullStarted");
        const { items: m, changes: p } = h ?? await this.persistenceAdapter.load();
        if (m) {
          if (o > 0)
            return;
          this.memory().splice(0, this.memoryArray().length, ...m), this.idIndex.clear(), this.memory().map((g, v) => {
            this.idIndex.set(N(g.id), /* @__PURE__ */ new Set([v]));
          });
        } else p && (p.added.forEach((g) => {
          const v = this.memory().findIndex((D) => D.id === g.id);
          if (v >= 0) {
            this.memory().splice(v, 1, g);
            return;
          }
          this.memory().push(g);
          const _ = this.memory().findIndex((D) => D === g);
          this.idIndex.set(N(g.id), /* @__PURE__ */ new Set([_]));
        }), p.modified.forEach((g) => {
          const v = this.memory().findIndex((_) => _.id === g.id);
          if (v === -1)
            throw new Error("Cannot resolve index for item");
          this.memory().splice(v, 1, g);
        }), p.removed.forEach((g) => {
          const v = this.memory().findIndex((_) => _.id === g.id);
          if (v === -1)
            throw new Error("Cannot resolve index for item");
          this.memory().splice(v, 1);
        }));
        this.rebuildIndices(), this.emit("persistence.received"), setTimeout(() => this.emit("persistence.pullCompleted"), 0);
      }, l = {
        added: [],
        modified: [],
        removed: []
      };
      let d = !1;
      const f = () => {
        if (!this.persistenceAdapter)
          throw new Error("Persistence adapter not found");
        if (o <= 0 && this.emit("persistence.pushStarted"), d || !ft(l))
          return;
        d = !0, o += 1;
        const h = this.memoryArray(), m = Object.assign({}, l);
        l.added = [], l.modified = [], l.removed = [], this.persistenceAdapter.save(h, m).then(() => {
          this.emit("persistence.transmitted");
        }).catch((p) => {
          this.emit("persistence.error", p instanceof Error ? p : new Error(p));
        }).finally(() => {
          o -= 1, d = !1, f(), o <= 0 && this.emit("persistence.pushCompleted");
        });
      };
      this.on("added", (h) => {
        if (!c) {
          a.added.push(h);
          return;
        }
        l.added.push(h), f();
      }), this.on("changed", (h) => {
        if (!c) {
          a.modified.push(h);
          return;
        }
        l.modified.push(h), f();
      }), this.on("removed", (h) => {
        if (!c) {
          a.removed.push(h);
          return;
        }
        l.removed.push(h), f();
      }), this.persistenceAdapter.register((h) => u(h)).then(async () => {
        if (!this.persistenceAdapter)
          throw new Error("Persistence adapter not found");
        let h = this.memoryArray();
        for (await u(); ft(a); ) {
          const m = a.added.splice(0), p = a.modified.splice(0), g = a.removed.splice(0);
          h = cs(this.memoryArray(), { added: m, modified: p, removed: g }), await this.persistenceAdapter.save(h, { added: m, modified: p, removed: g }).then(() => {
            this.emit("persistence.transmitted");
          });
        }
        await u(), c = !0, setTimeout(() => this.emit("persistence.init"), 0);
      }).catch((h) => {
        this.emit("persistence.error", h instanceof Error ? h : new Error(h));
      });
    }
  }
  isPulling() {
    var e;
    return (e = this.isPullingSignal.get()) !== null && e !== void 0 ? e : !1;
  }
  isPushing() {
    var e;
    return (e = this.isPushingSignal.get()) !== null && e !== void 0 ? e : !1;
  }
  isLoading() {
    const e = this.isPulling(), n = this.isPushing();
    return e || n;
  }
  getDebugMode() {
    return this.debugMode;
  }
  setDebugMode(e) {
    this.debugMode = e;
  }
  profile(e, n) {
    if (!this.debugMode)
      return e();
    const r = performance.now(), s = e(), i = performance.now();
    return n(i - r), s;
  }
  executeInDebugMode(e) {
    if (!this.debugMode)
      return;
    const n = new Error().stack || "";
    e(n);
  }
  rebuildIndices() {
    this.indicesOutdated = !0, !this.batchOperationInProgress && this.rebuildAllIndices();
  }
  rebuildAllIndices() {
    this.idIndex.clear(), this.memory().map((e, n) => {
      this.idIndex.set(N(e.id), /* @__PURE__ */ new Set([n]));
    }), this.indexProviders.forEach((e) => e.rebuild(this.memoryArray())), this.indicesOutdated = !1;
  }
  getItemAndIndex(e) {
    const n = this.indicesOutdated ? { matched: !1, positions: [], optimizedSelector: e } : me(this.indexProviders, e), s = (n.matched ? n.positions.map((o) => this.memoryArray()[o]) : this.memory()).find((o) => ot(o, e)), i = n.matched && n.positions.find((o) => this.memoryArray()[o] === s) || this.memory().findIndex((o) => o === s);
    if (s == null)
      return { item: null, index: -1 };
    if (i === -1)
      throw new Error("Cannot resolve index for item");
    return { item: s, index: i };
  }
  memory() {
    return this.options.memory;
  }
  memoryArray() {
    return this.memory().map((e) => e);
  }
  transform(e) {
    return this.options.transform ? this.options.transform(e) : e;
  }
  getItems(e) {
    return this.profile(() => {
      const n = e && !this.indicesOutdated ? me(this.indexProviders, e) : { matched: !1, positions: [], optimizedSelector: e }, r = (o) => n.optimizedSelector == null || Object.keys(n.optimizedSelector).length <= 0 ? !0 : ot(o, n.optimizedSelector);
      if (!n.matched)
        return this.memory().filter(r);
      const s = this.memoryArray(), i = n.positions.map((o) => s[o]);
      return this.emit("getItems", e), i.filter(r);
    }, (n) => this.executeInDebugMode((r) => this.emit("_debug.getItems", r, e, n)));
  }
  /**
   * Disposes the collection, runs the dispose method of the persistence adapter
   * and clears all internal data structures.
   */
  async dispose() {
    var e;
    !((e = this.persistenceAdapter) === null || e === void 0) && e.unregister && await this.persistenceAdapter.unregister(), this.persistenceAdapter = null, this.memory().map(() => this.memory().pop()), this.idIndex.clear(), this.indexProviders = [], this.isDisposed = !0;
  }
  find(e, n) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (e !== void 0 && (!e || typeof e != "object"))
      throw new Error("Invalid selector");
    const r = new rs(() => this.getItems(e), Object.assign(Object.assign({ reactive: this.options.reactivity }, n), { transform: this.transform.bind(this), bindEvents: (s) => (this.addListener("persistence.received", s), this.addListener("added", s), this.addListener("changed", s), this.addListener("removed", s), this.emit("observer.created", e, n), () => {
      this.removeListener("persistence.received", s), this.removeListener("added", s), this.removeListener("changed", s), this.removeListener("removed", s), this.emit("observer.disposed", e, n);
    }) }));
    return this.emit("find", e, n, r), this.executeInDebugMode((s) => this.emit("_debug.find", s, e, n, r)), r;
  }
  findOne(e, n) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    const s = this.find(e, Object.assign({ limit: 1 }, n)).fetch()[0] || void 0;
    return this.emit("findOne", e, n, s), this.executeInDebugMode((i) => this.emit("_debug.findOne", i, e, n, s)), s;
  }
  batch(e) {
    this.batchOperationInProgress = !0, e(), this.batchOperationInProgress = !1, this.rebuildAllIndices();
  }
  insert(e) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (!e)
      throw new Error("Invalid item");
    const n = Object.assign({ id: Wt() }, e);
    if (this.idIndex.has(N(n.id)))
      throw new Error("Item with same id already exists");
    this.memory().push(n);
    const r = this.memory().findIndex((s) => s === n);
    return this.idIndex.set(N(n.id), /* @__PURE__ */ new Set([r])), this.rebuildIndices(), this.emit("added", n), this.emit("insert", n), this.executeInDebugMode((s) => this.emit("_debug.insert", s, n)), n.id;
  }
  insertMany(e) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (!e)
      throw new Error("Invalid items");
    if (e.length === 0)
      return [];
    const n = [];
    return this.batch(() => {
      e.forEach((r) => {
        n.push(this.insert(r));
      });
    }), n;
  }
  updateOne(e, n) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (!e)
      throw new Error("Invalid selector");
    if (!n)
      throw new Error("Invalid modifier");
    const { item: r, index: s } = this.getItemAndIndex(e);
    if (r == null)
      return 0;
    const i = Ne(at(r), n), o = this.findOne({ id: i.id }, { reactive: !1 });
    if (!oe(o, Object.assign(Object.assign({}, o), { id: i.id })))
      throw new Error("Item with same id already exists");
    return this.memory().splice(s, 1, i), this.rebuildIndices(), this.emit("changed", i, n), this.emit("updateOne", e, n), this.executeInDebugMode((c) => this.emit("_debug.updateOne", c, e, n)), 1;
  }
  updateMany(e, n) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (!e)
      throw new Error("Invalid selector");
    if (!n)
      throw new Error("Invalid modifier");
    const r = this.getItems(e), s = [];
    return r.forEach((i) => {
      const { index: o } = this.getItemAndIndex({ id: i.id });
      if (o === -1)
        throw new Error("Cannot resolve index for item");
      const c = Ne(at(i), n);
      this.memory().splice(o, 1, c), s.push(c);
    }), this.rebuildIndices(), s.forEach((i) => {
      this.emit("changed", i, n);
    }), this.emit("updateMany", e, n), this.executeInDebugMode((i) => this.emit("_debug.updateMany", i, e, n)), s.length;
  }
  removeOne(e) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (!e)
      throw new Error("Invalid selector");
    const { item: n, index: r } = this.getItemAndIndex(e);
    return n != null && (this.memory().splice(r, 1), this.idIndex.delete(N(n.id)), this.rebuildIndices(), this.emit("removed", n)), this.emit("removeOne", e), this.executeInDebugMode((s) => this.emit("_debug.removeOne", s, e)), n == null ? 0 : 1;
  }
  removeMany(e) {
    if (this.isDisposed)
      throw new Error("Collection is disposed");
    if (!e)
      throw new Error("Invalid selector");
    const n = this.getItems(e);
    return n.forEach((r) => {
      const s = this.memory().findIndex((i) => i === r);
      if (s === -1)
        throw new Error("Cannot resolve index for item");
      this.memory().splice(s, 1), this.idIndex.delete(N(r.id)), this.rebuildIndices();
    }), n.forEach((r) => {
      this.emit("removed", r);
    }), this.emit("removeMany", e), this.executeInDebugMode((r) => this.emit("_debug.removeMany", r, e)), n.length;
  }
}
E.collections = [];
E.debugMode = !1;
E.batchOperationInProgress = !1;
E.enableDebugMode = () => {
  E.debugMode = !0, E.collections.forEach((t) => {
    t.setDebugMode(!0);
  });
};
function bs(t) {
  return t;
}
function en(t, e) {
  const { serialize: n = JSON.stringify, deserialize: r = JSON.parse } = e || {}, s = `signaldb-collection-${t}`;
  function i() {
    return r(localStorage.getItem(s) || "[]");
  }
  return {
    async load() {
      const o = i();
      return Promise.resolve({ items: o });
    },
    async save(o, { added: c, modified: a, removed: u }) {
      const l = i();
      return c.forEach((d) => {
        l.push(d);
      }), a.forEach((d) => {
        const f = l.findIndex(({ id: h }) => h === d.id);
        /* istanbul ignore if -- @preserve */
        if (f === -1)
          throw new Error(`Item with ID ${d.id} not found`);
        l[f] = d;
      }), u.forEach((d) => {
        const f = l.findIndex(({ id: h }) => h === d.id);
        /* istanbul ignore if -- @preserve */
        if (f === -1)
          throw new Error(`Item with ID ${d.id} not found`);
        l.splice(f, 1);
      }), localStorage.setItem(s, n(l)), Promise.resolve();
    },
    async register() {
      return Promise.resolve();
    }
  };
}
function as(t, e) {
  const { serialize: n = JSON.stringify, deserialize: r = JSON.parse } = e || {};
  let s = null;
  async function i() {
    const o = await import("fs");
    if (!await o.promises.access(t).then(() => !0).catch(() => !1))
      return [];
    const a = await o.promises.readFile(t, "utf8").catch((u) => {
      /* istanbul ignore next -- @preserve */
      if (u.code === "ENOENT")
        return "[]";
      /* istanbul ignore next -- @preserve */
      throw u;
    });
    return r(a);
  }
  return {
    async register(o) {
      if (typeof window < "u")
        throw new Error("Filesystem adapter is not supported in the browser");
      const c = await import("fs");
      await c.promises.access(t).then(() => !0).catch(() => !1) || await c.promises.writeFile(t, "[]"), c.watch(t, { encoding: "utf8" }, () => {
        o();
      });
    },
    async load() {
      if (typeof window < "u")
        throw new Error("Filesystem adapter is not supported in the browser");
      return s && await s, { items: await i() };
    },
    async save(o, { added: c, modified: a, removed: u }) {
      if (typeof window < "u")
        throw new Error("Filesystem adapter is not supported in the browser");
      s && await s, s = i().then((l) => {
        const d = l.slice();
        return c.forEach((f) => {
          d.push(f);
        }), a.forEach((f) => {
          const h = d.findIndex(({ id: m }) => m === f.id);
          /* istanbul ignore if -- @preserve */
          if (h === -1)
            throw new Error(`Item with ID ${f.id} not found`);
          d[h] = f;
        }), u.forEach((f) => {
          const h = d.findIndex(({ id: m }) => m === f.id);
          /* istanbul ignore if -- @preserve */
          if (h === -1)
            throw new Error(`Item with ID ${f.id} not found`);
          d.splice(h, 1);
        }), d;
      }).then(async (l) => {
        await (await import("fs")).promises.writeFile(t, n(l));
      }).then(() => {
        s = null;
      }), await s;
    }
  };
}
function us(t) {
  return typeof window > "u" ? as(`persistent-collection-${t}.json`) : en(t);
}
class Es extends E {
  constructor(e, n) {
    super(Object.assign({ persistence: us(e) }, n));
  }
}
function ls(t, e, n) {
  var r;
  const s = (r = n == null ? void 0 : n.cacheTimeout) !== null && r !== void 0 ? r : 0;
  let i = !1, o = null, c = null, a = null;
  return (...u) => {
    if (a == null)
      c && (clearTimeout(c), c = null), a = e(...u).then((l) => (s > 0 && (c = setTimeout(() => {
        i = !1, o = null, a = null;
      }, s)), i = !0, o = l, n != null && n.onResolve && n.onResolve(o), l));
    else if (i)
      return a;
    return t(...u);
  };
}
function ds(t, e, n) {
  var r;
  const s = (r = n == null ? void 0 : n.readPreference) !== null && r !== void 0 ? r : "secondary", i = s === "primary" ? t : e, o = s === "primary" ? e : t;
  let c = null;
  const a = ls(() => i.load(), () => o.load(), {
    cacheTimeout: 100,
    onResolve: (u) => {
      var l, d, f;
      c && c(), i.save(u.items || [], {
        added: ((l = u.changes) === null || l === void 0 ? void 0 : l.added) || [],
        modified: ((d = u.changes) === null || d === void 0 ? void 0 : d.modified) || [],
        removed: ((f = u.changes) === null || f === void 0 ? void 0 : f.removed) || []
      });
    }
  });
  return {
    async register(u) {
      c = u, await Promise.all([t.register(u), e.register(u)]);
    },
    async load() {
      return a();
    },
    async save(u, l) {
      await Promise.all([
        i.save(u, l),
        o.save(u, l)
      ]);
    }
  };
}
function hs(t) {
  return {
    async register(e) {
      t.registerRemoteChange && await t.registerRemoteChange(e);
    },
    load: () => t.pull(),
    save: (e, n) => {
      if (!t.push)
        throw new Error("Pushing is not configured for this collection. Try to pass a `push` function to the collection options.");
      return t.push(n, e);
    }
  };
}
class fs extends E {
  constructor(e) {
    var n, r;
    const s = hs({
      registerRemoteChange: e.registerRemoteChange,
      pull: async () => {
        this.isPullingRemoteSignal.set(!0);
        try {
          return await e.pull();
        } finally {
          this.isPullingRemoteSignal.set(!1);
        }
      },
      push: e.push ? async (o, c) => {
        if (!e.push)
          throw new Error("Pushing is not configured for this collection. Try to pass a `push` function to the collection options.");
        this.isPushingRemoteSignal.set(!0);
        try {
          await e.push(o, c);
        } finally {
          this.isPushingRemoteSignal.set(!1);
        }
      } : void 0
    }), i = e != null && e.persistence ? ds(s, e.persistence) : s;
    super(Object.assign(Object.assign({}, e), { persistence: i })), this.isPullingRemoteSignal = Y((n = e.reactivity) === null || n === void 0 ? void 0 : n.create(), !1), this.isPushingRemoteSignal = Y((r = e.reactivity) === null || r === void 0 ? void 0 : r.create(), !1);
  }
  isLoading() {
    const e = this.isPullingRemoteSignal.get(), n = this.isPushingRemoteSignal.get(), r = super.isLoading();
    return e || n || r;
  }
}
class $s extends fs {
  /**
   * @param options {Object} - Options for the collection.
   * @param options.fetchQueryItems {Function} - A function that fetches items from the server. It takes the selector as an argument and returns a promise that resolves to an object with an `items` property.
   * @param options.purgeDelay {Number} - The delay in milliseconds before purging an item from the cache.
   */
  constructor(e) {
    var n, r, s;
    let i;
    if (super(Object.assign(Object.assign({}, e), { pull: () => Promise.resolve({
      items: [...this.itemsCache.values()].reduce((o, c) => {
        const a = [...o];
        return c.forEach((u) => {
          const l = a.findIndex((d) => d.id === u.id);
          if (l === -1) {
            a.push(u);
            return;
          }
          a[l] = Object.assign(Object.assign({}, a[l]), u);
        }), a;
      }, [])
    }), registerRemoteChange: async (o) => (i = o, Promise.resolve()) })), this.activeObservers = /* @__PURE__ */ new Map(), this.observerTimeouts = /* @__PURE__ */ new Map(), this.idQueryCache = /* @__PURE__ */ new Map(), this.itemsCache = /* @__PURE__ */ new Map(), this.triggerReload = null, this.reactivityAdapter = null, this.loadingSignals = /* @__PURE__ */ new Map(), this.purgeDelay = (n = e.purgeDelay) !== null && n !== void 0 ? n : 1e4, this.isFetchingSignal = Y((r = e.reactivity) === null || r === void 0 ? void 0 : r.create(), !1), !i)
      throw new Error("No triggerRemoteChange method found. Looks like your persistence adapter was not registered");
    this.triggerReload = i, this.reactivityAdapter = (s = e.reactivity) !== null && s !== void 0 ? s : null, this.fetchQueryItems = e.fetchQueryItems, this.on("observer.created", (o) => this.handleObserverCreation(o ?? {})), this.on("observer.disposed", (o) => setTimeout(() => this.handleObserverDisposal(o ?? {}), 100)), e.registerRemoteChange && e.registerRemoteChange(() => this.forceRefetch());
  }
  /**
   * @summary Registers a query manually that items should be fetched for it
   * @param selector {Object} Selector of the query
   */
  registerQuery(e) {
    this.handleObserverCreation(e);
  }
  /**
   * @summary Unregisters a query manually that items are not fetched anymore for it
   * @param selector {Object} Selector of the query
   */
  unregisterQuery(e) {
    this.handleObserverDisposal(e);
  }
  // eslint-disable-next-line class-methods-use-this
  getKeyForSelector(e) {
    return JSON.stringify(e);
  }
  async forceRefetch() {
    return Promise.all([...this.activeObservers.values()].map(({ selector: e }) => this.fetchSelector(e))).then(() => {
    });
  }
  fetchSelector(e) {
    return this.isFetchingSignal.set(!0), this.fetchQueryItems(e).then((n) => {
      if (!n.items)
        throw new Error("AutoFetchCollection currently only works with a full item response");
      if (this.itemsCache.set(this.getKeyForSelector(e), n.items), n.items.forEach((r) => {
        var s;
        const i = (s = this.idQueryCache.get(r.id)) !== null && s !== void 0 ? s : [];
        i.push(e), this.idQueryCache.set(r.id, i);
      }), this.setLoading(e, !0), this.once("persistence.received", () => {
        this.setLoading(e, !1);
      }), !this.triggerReload)
        throw new Error("No triggerReload method found. Looks like your persistence adapter was not registered");
      this.triggerReload();
    }).catch((n) => {
      this.emit("persistence.error", n);
    }).finally(() => {
      this.isFetchingSignal.set(!1);
    });
  }
  handleObserverCreation(e) {
    var n, r;
    const s = (r = (n = this.activeObservers.get(this.getKeyForSelector(e))) === null || n === void 0 ? void 0 : n.count) !== null && r !== void 0 ? r : 0;
    this.activeObservers.set(this.getKeyForSelector(e), {
      selector: e,
      count: s + 1
    });
    const i = this.observerTimeouts.get(this.getKeyForSelector(e));
    i && clearTimeout(i), s === 0 && this.fetchSelector(e);
  }
  handleObserverDisposal(e) {
    var n, r;
    const i = ((r = (n = this.activeObservers.get(this.getKeyForSelector(e))) === null || n === void 0 ? void 0 : n.count) !== null && r !== void 0 ? r : 0) - 1;
    if (i > 0) {
      this.activeObservers.set(this.getKeyForSelector(e), {
        selector: e,
        count: i
      });
      return;
    }
    const o = this.observerTimeouts.get(this.getKeyForSelector(e));
    o && clearTimeout(o);
    const c = () => {
      if (this.activeObservers.delete(this.getKeyForSelector(e)), this.itemsCache.delete(this.getKeyForSelector(e)), !this.triggerReload)
        throw new Error("No triggerReload method found. Looks like your persistence adapter was not registered");
      this.triggerReload();
    };
    if (this.purgeDelay === 0) {
      c();
      return;
    }
    this.observerTimeouts.set(this.getKeyForSelector(e), setTimeout(c, this.purgeDelay));
  }
  ensureSignal(e) {
    if (!this.reactivityAdapter)
      throw new Error("No reactivity adapter found");
    return this.loadingSignals.has(this.getKeyForSelector(e)) || this.loadingSignals.set(this.getKeyForSelector(e), Y(this.reactivityAdapter.create(), !1)), this.loadingSignals.get(this.getKeyForSelector(e));
  }
  setLoading(e, n) {
    this.ensureSignal(e).set(n);
  }
  /**
   * @summary Indicates wether a query is currently been loaded
   * @param selector {Object} Selector of the query
   * @returns The loading state
   */
  isLoading(e) {
    const n = this.isPushing();
    return e ? this.ensureSignal(e).get() || n : this.isFetchingSignal.get() || n;
  }
}
function Is(t, e) {
  const { serialize: n = JSON.stringify, deserialize: r = JSON.parse } = e || {};
  let s = null;
  async function i() {
    const a = await (await (await navigator.storage.getDirectory()).getFileHandle(t, { create: !0 })).getFile().then((u) => u.text());
    return r(a || "[]");
  }
  return {
    async register(o) {
      await (await navigator.storage.getDirectory()).getFileHandle(t, { create: !0 }), o();
    },
    async load() {
      return s && await s, { items: await i() };
    },
    async save(o, { added: c, modified: a, removed: u }) {
      s && await s;
      const d = await (await navigator.storage.getDirectory()).getFileHandle(t, { create: !0 });
      if (c.length === 0 && a.length === 0 && u.length === 0) {
        const f = await d.createWritable();
        await f.write(n(o)), await f.close(), await s;
        return;
      }
      s = i().then((f) => {
        const h = f.slice();
        return c.forEach((m) => {
          h.push(m);
        }), a.forEach((m) => {
          const p = h.findIndex(({ id: g }) => g === m.id);
          /* istanbul ignore if -- @preserve */
          if (p === -1)
            throw new Error(`Item with ID ${m.id} not found`);
          h[p] = m;
        }), u.forEach((m) => {
          const p = h.findIndex(({ id: g }) => g === m.id);
          /* istanbul ignore if -- @preserve */
          if (p === -1)
            throw new Error(`Item with ID ${m.id} not found`);
          h.splice(p, 1);
        }), h;
      }).then(async (f) => {
        const h = await d.createWritable();
        await h.write(n(f)), await h.close();
      }).then(() => {
        s = null;
      }), await s;
    }
  };
}
function Ss(t) {
  return t;
}
function xs(t) {
  return t;
}
function ps(t, e, n = {}) {
  let r, s;
  const { leading: i = !1, trailing: o = !0 } = n;
  function c(...a) {
    const u = i && !r, l = o && !r;
    return r && clearTimeout(r), r = setTimeout(() => {
      r = null, o && !u && (s = t.apply(this, a));
    }, e), u ? s = t.apply(this, a) : l || (s = null), s;
  }
  return c;
}
class ms {
  constructor() {
    this.queue = [], this.pendingPromise = !1;
  }
  /**
   * Method to add a new promise to the queue and returns a promise that resolves when this task is done
   * @param task Function that returns a promise that will be added to the queue
   * @returns Promise that resolves when the task is done
   */
  add(e) {
    return new Promise((n, r) => {
      this.queue.push(() => e().then(n).catch((s) => {
        throw r(s), s;
      })), this.dequeue();
    });
  }
  /**
   * Method to check if there is a pending promise in the queue
   * @returns True if there is a pending promise, false otherwise
   */
  hasPendingPromise() {
    return this.pendingPromise;
  }
  /**
   * Method to process the queue
   */
  dequeue() {
    if (this.pendingPromise || this.queue.length === 0)
      return;
    const e = this.queue.shift();
    e && (this.pendingPromise = !0, e().then(() => {
      this.pendingPromise = !1, this.dequeue();
    }).catch(() => {
      this.pendingPromise = !1, this.dequeue();
    }));
  }
}
function De(t, e) {
  const n = [], r = [], s = [];
  return t.forEach((i) => {
    const o = e.find((c) => c.id === i.id);
    if (!o) {
      s.push(i);
      return;
    }
    oe(o, i) || r.push(o);
  }), e.forEach((i) => {
    t.find((c) => c.id === i.id) || n.push(i);
  }), { added: n, modified: r, removed: s };
}
function pt(t, e) {
  if (e.items != null)
    return e.items;
  const n = t || [];
  return e.changes.added.forEach((r) => n.push(r)), e.changes.modified.forEach((r) => {
    const s = n.findIndex((i) => i.id === r.id);
    s !== -1 && (n[s] = r);
  }), e.changes.removed.forEach((r) => {
    const s = n.findIndex((i) => i.id === r.id);
    s !== -1 && n.splice(s, 1);
  }), n;
}
function mt(t, e) {
  const n = new E();
  return t.forEach((r) => n.insert(r)), e.forEach((r) => {
    if (r.type === "remove") {
      n.removeOne({ id: r.data });
      return;
    }
    const s = { id: r.data.id }, i = n.findOne(s);
    if (r.type === "insert") {
      i ? n.updateOne(s, { $set: r.data }) : n.insert(r.data);
      return;
    }
    i ? n.updateOne(s, r.data.modifier) : n.insert(Ne(s, r.data.modifier));
  }), n.find().fetch();
}
function tn(t) {
  return t.added.length > 0 || t.modified.length > 0 || t.removed.length > 0;
}
function gs(t, e) {
  return tn(De(t, e));
}
async function ys({ changes: t, lastSnapshot: e, data: n, pull: r, push: s, insert: i, update: o, remove: c }) {
  let a = n, u = e || [], l = pt(e, a);
  if (t.length > 0) {
    const f = mt(u, t);
    if (gs(u, f)) {
      const h = mt(l, t), m = De(l, h);
      tn(m) && (await s(m), a = await r(), l = pt(l, a)), u = f;
    }
  }
  const d = a.changes == null ? De(u, a.items) : a.changes;
  return d.added.forEach((f) => i(f)), d.modified.forEach((f) => o(f.id, { $set: f })), d.removed.forEach((f) => c(f.id)), l;
}
class _s {
  /**
   * @param options Collection options
   * @param options.pull Function to pull data from remote source.
   * @param options.push Function to push data to remote source.
   * @param [options.registerRemoteChange] Function to register a callback for remote changes.
   * @param [options.id] Unique identifier for this sync manager. Only nessesary if you have multiple sync managers.
   * @param [options.persistenceAdapter] Persistence adapter to use for storing changes, snapshots and sync operations.
   * @param [options.reactivity] Reactivity adapter to use for reactivity.
   * @param [options.onError] Function to handle errors that occur async during syncing.
   */
  constructor(e) {
    var n, r;
    this.collections = /* @__PURE__ */ new Map(), this.syncQueues = /* @__PURE__ */ new Map(), this.isDisposed = !1, this.instanceId = Wt(), this.deboucedPush = ps((p) => {
      this.pushChanges(p).catch(() => {
      });
    }, 100), this.options = e;
    const s = (n = this.options.id) !== null && n !== void 0 ? n : "default-sync-manager", { reactivity: i } = this.options;
    let o = () => {
    }, c = () => {
    }, a = () => {
    }, u = () => {
    };
    const l = (r = e.persistenceAdapter) !== null && r !== void 0 ? r : en, d = l(`${s}-changes`, (p) => {
      o = p;
    }), f = l(`${s}-remote-changes`, (p) => {
      c = p;
    }), h = l(`${s}-snapshots`, (p) => {
      a = p;
    }), m = l(`${s}-sync-operations`, (p) => {
      u = p;
    });
    this.changes = new E({
      persistence: d,
      reactivity: i
    }), this.remoteChanges = new E({
      persistence: f,
      reactivity: i
    }), this.snapshots = new E({
      persistence: h,
      reactivity: i
    }), this.syncOperations = new E({
      persistence: m,
      reactivity: i
    }), this.changes.on("persistence.error", (p) => o(p)), this.remoteChanges.on("persistence.error", (p) => c(p)), this.snapshots.on("persistence.error", (p) => a(p)), this.syncOperations.on("persistence.error", (p) => u(p)), this.persistenceReady = Promise.all([
      new Promise((p, g) => {
        this.syncOperations.once("persistence.error", g), this.syncOperations.once("persistence.init", p);
      }),
      new Promise((p, g) => {
        this.changes.once("persistence.error", g), this.changes.once("persistence.init", p);
      }),
      new Promise((p, g) => {
        this.remoteChanges.once("persistence.error", g), this.remoteChanges.once("persistence.init", p);
      }),
      new Promise((p, g) => {
        this.snapshots.once("persistence.error", g), this.snapshots.once("persistence.init", p);
      })
    ]).then(() => {
    }), this.changes.setMaxListeners(1e3), this.remoteChanges.setMaxListeners(1e3), this.snapshots.setMaxListeners(1e3), this.syncOperations.setMaxListeners(1e3);
  }
  getSyncQueue(e) {
    return this.syncQueues.get(e) == null && this.syncQueues.set(e, new ms()), this.syncQueues.get(e);
  }
  /**
   * Clears all internal data structures
   */
  async dispose() {
    this.collections.clear(), this.syncQueues.clear(), await Promise.all([
      this.changes.dispose(),
      this.remoteChanges.dispose(),
      this.snapshots.dispose(),
      this.syncOperations.dispose()
    ]), this.isDisposed = !0;
  }
  /**
   * Gets a collection with it's options by name
   * @param name Name of the collection
   * @throws Will throw an error if the name wasn't found
   * @returns Tuple of collection and options
   */
  getCollection(e) {
    const n = this.collections.get(e);
    if (n == null)
      throw new Error(`Collection with id '${e}' not found`);
    return n;
  }
  /**
   * Adds a collection to the sync manager.
   * @param collection Collection to add
   * @param options Options for the collection. The object needs at least a `name` property.
   * @param options.name Unique name of the collection
   */
  addCollection(e, n) {
    if (this.isDisposed)
      throw new Error("SyncManager is disposed");
    this.options.registerRemoteChange && this.options.registerRemoteChange(n, async (r) => {
      if (r == null)
        await this.sync(n.name);
      else {
        const s = Date.now(), i = this.syncOperations.insert({
          start: s,
          collectionName: n.name,
          instanceId: this.instanceId,
          status: "active"
        });
        await this.syncWithData(n.name, r).then(() => {
          this.syncOperations.removeMany({
            id: { $ne: i },
            collectionName: n.name,
            $or: [
              { end: { $lte: s } },
              { status: "active" }
            ]
          }), this.syncOperations.updateOne({ id: i }, {
            $set: { status: "done", end: Date.now() }
          });
        }).catch((o) => {
          throw this.options.onError && this.options.onError(n, o), this.syncOperations.updateOne({ id: i }, {
            $set: { status: "error", end: Date.now(), error: o.stack || o.message }
          }), o;
        });
      }
    }), this.collections.set(n.name, [e, n]), e.on("added", (r) => {
      if (this.remoteChanges.findOne({ collectionName: n.name, type: "insert", data: r })) {
        this.remoteChanges.removeOne({ collectionName: n.name, type: "insert", data: r });
        return;
      }
      this.changes.insert({
        collectionName: n.name,
        time: Date.now(),
        type: "insert",
        data: r
      }), this.schedulePush(n.name);
    }), e.on("changed", ({ id: r }, s) => {
      const i = { id: r, modifier: s };
      if (this.remoteChanges.findOne({ collectionName: n.name, type: "update", data: i })) {
        this.remoteChanges.removeOne({ collectionName: n.name, type: "update", data: i });
        return;
      }
      this.changes.insert({
        collectionName: n.name,
        time: Date.now(),
        type: "update",
        data: i
      }), this.schedulePush(n.name);
    }), e.on("removed", ({ id: r }) => {
      if (this.remoteChanges.findOne({ collectionName: n.name, type: "remove", data: r })) {
        this.remoteChanges.removeOne({ collectionName: n.name, type: "remove", data: r });
        return;
      }
      this.changes.insert({
        collectionName: n.name,
        time: Date.now(),
        type: "remove",
        data: r
      }), this.schedulePush(n.name);
    });
  }
  schedulePush(e) {
    this.deboucedPush(e);
  }
  /**
   * Starts the sync process for all collections
   */
  async syncAll() {
    if (this.isDisposed)
      throw new Error("SyncManager is disposed");
    const e = [];
    if (await Promise.all([...this.collections.keys()].map((n) => this.sync(n).catch((r) => {
      e.push({ id: n, error: r });
    }))), e.length > 0)
      throw new Error(`Error while syncing collections:
${e.map((n) => `${n.id}: ${n.error.message}`).join(`

`)}`);
  }
  /**
   * Checks if a collection is currently beeing synced
   * @param [name] Name of the collection. If not provided, it will check if any collection is currently beeing synced.
   * @returns True if the collection is currently beeing synced, false otherwise.
   */
  isSyncing(e) {
    return this.syncOperations.findOne(Object.assign(Object.assign({}, e ? { collectionName: e } : {}), { status: "active" }), { fields: { status: 1 } }) != null;
  }
  /**
   * Checks if the sync manager is ready to sync.
   * @returns A promise that resolves when the sync manager is ready to sync.
   */
  async isReady() {
    await this.persistenceReady;
  }
  /**
   * Starts the sync process for a collection
   * @param name Name of the collection
   * @param options Options for the sync process.
   * @param options.force If true, the sync process will be started even if there are no changes and onlyWithChanges is true.
   * @param options.onlyWithChanges If true, the sync process will only be started if there are changes.
   */
  async sync(e, n = {}) {
    if (this.isDisposed)
      throw new Error("SyncManager is disposed");
    await this.isReady();
    const s = this.getCollection(e)[1], i = this.syncOperations.find({
      collectionName: e,
      instanceId: this.instanceId,
      status: "active"
    }).count() > 0, o = Date.now();
    let c = null;
    await new Promise((u) => {
      setTimeout(u, 0);
    });
    const a = async () => {
      const u = this.syncOperations.findOne({ collectionName: e, status: "done" }, { sort: { end: -1 } });
      if (n != null && n.onlyWithChanges && this.changes.find({
        collectionName: e,
        $and: [
          { time: { $lte: o } }
        ]
      }, { sort: { time: 1 } }).count() === 0)
        return;
      i || (c = this.syncOperations.insert({
        start: o,
        collectionName: e,
        instanceId: this.instanceId,
        status: "active"
      }));
      const l = await this.options.pull(s, {
        lastFinishedSyncStart: u == null ? void 0 : u.start,
        lastFinishedSyncEnd: u == null ? void 0 : u.end
      });
      await this.syncWithData(e, l);
    };
    await (n != null && n.force ? a() : this.getSyncQueue(e).add(a)).catch((u) => {
      throw c != null && (this.options.onError && this.options.onError(s, u), this.syncOperations.updateOne({ id: c }, {
        $set: { status: "error", end: Date.now(), error: u.stack || u.message }
      })), u;
    }), c != null && (this.syncOperations.removeMany({
      id: { $ne: c },
      collectionName: e,
      $or: [
        { end: { $lte: o } },
        { status: "active" }
      ]
    }), this.syncOperations.updateOne({ id: c }, {
      $set: { status: "done", end: Date.now() }
    }));
  }
  /**
   * Starts the push process for a collection (sync process but only if there are changes)
   * @param name Name of the collection
   */
  async pushChanges(e) {
    await this.sync(e, {
      onlyWithChanges: !0
    });
  }
  async syncWithData(e, n) {
    const r = this.getCollection(e), [s, i] = r, o = Date.now(), c = this.syncOperations.findOne({ collectionName: e, status: "done" }, { sort: { end: -1 } }), a = this.snapshots.findOne({ collectionName: e }, { sort: { time: -1 } }), u = this.changes.find({
      collectionName: e,
      $and: [
        { time: { $lte: o } }
      ]
    }, { sort: { time: 1 } }).fetch();
    await ys({
      changes: u,
      lastSnapshot: a == null ? void 0 : a.items,
      data: n,
      pull: () => this.options.pull(i, {
        lastFinishedSyncStart: c == null ? void 0 : c.start,
        lastFinishedSyncEnd: c == null ? void 0 : c.end
      }),
      push: (l) => this.options.push(i, { changes: l }),
      insert: (l) => {
        if (this.remoteChanges.insert({
          collectionName: e,
          time: Date.now(),
          type: "insert",
          data: l
        }), l.id && s.findOne({ id: l.id })) {
          s.updateOne({ id: l.id }, { $set: l });
          return;
        }
        s.insert(l);
      },
      update: (l, d) => {
        if (this.remoteChanges.insert({
          collectionName: e,
          time: Date.now(),
          type: "update",
          data: { id: l, modifier: d }
        }), l && !s.findOne({ id: l })) {
          s.insert(Object.assign(Object.assign({}, d.$set), { id: l }));
          return;
        }
        s.updateOne({ id: l }, d);
      },
      remove: (l) => {
        this.remoteChanges.insert({
          collectionName: e,
          time: Date.now(),
          type: "remove",
          data: l
        }), s.removeOne({ id: l });
      }
    }).then(async (l) => {
      this.snapshots.removeMany({ collectionName: e, time: { $lte: o } }), this.changes.removeMany({
        collectionName: e,
        id: { $in: u.map((d) => d.id) }
      }), this.snapshots.insert({
        time: o,
        collectionName: e,
        items: l
      }), await new Promise((d) => {
        setTimeout(d, 0);
      });
    }).then(() => this.sync(e, {
      force: !0,
      onlyWithChanges: !0
    }));
  }
}
export {
  $s as AutoFetchCollection,
  E as Collection,
  Es as PersistentCollection,
  fs as ReplicatedCollection,
  _s as SyncManager,
  ds as combinePersistenceAdapters,
  as as createFilesystemAdapter,
  Os as createIndex,
  ws as createIndexProvider,
  en as createLocalStorageAdapter,
  Ss as createMemoryAdapter,
  Is as createOPFSAdapter,
  bs as createPersistenceAdapter,
  xs as createReactivityAdapter
};
//# sourceMappingURL=index.mjs.map
